/**
 * Generated by orval v7.11.2 🍺
 * Do not edit manually.
 * consumer-sender-services
 * OpenAPI spec version: 1.0.0-20260604-074350-90bb2e56
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import {
  useCallback
} from 'react';

import { useMutator } from '../../useMutator';
export const AgtValue = {
  type: 'AGT',
} as const;
export type Agt = typeof AgtValue;

export interface AGTChoice {
  price: Price;
  maxInsuredValue: number;
  userInputRequired: boolean;
  excludes?: OptionKey[];
  implies?: OptionKey[];
  excludesImpliesKey: OptionKey;
  isExcludedBy?: OptionKey[];
  type: 'AGT';
}

export type AGTOptionKeyType = typeof AGTOptionKeyType[keyof typeof AGTOptionKeyType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AGTOptionKeyType = {
  AGTOptionKey: 'AGTOptionKey',
} as const;

export interface AGTOptionKey {
  type: AGTOptionKeyType;
}

export interface AddDiscountCodeToBasketItemRequest {
  discountCode: string;
}

export interface AddItemSelectionToBasketRequest {
  toCountry: string;
  parcels?: ParcelTypeSelection[];
}

export interface AddItemSelectionToBasketResponse {
  basketItemIds?: string[];
}

export interface AuthenticationError {
  message: string;
  errorId: string;
  type: 'AuthenticationError';
}

export interface AuthenticationError1 {
  message: string;
  errorId: string;
  type: 'AuthenticationError';
}

export const BmcValue = {
  type: 'BMC',
} as const;
export type Bmc = typeof BmcValue;

export interface BMCChoice {
  price: Price;
  userInputRequired: boolean;
  excludes?: OptionKey[];
  implies?: OptionKey[];
  excludesImpliesKey: OptionKey;
  isExcludedBy?: OptionKey[];
  type: 'BMC';
}

export type BMCOptionKeyType = typeof BMCOptionKeyType[keyof typeof BMCOptionKeyType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BMCOptionKeyType = {
  BMCOptionKey: 'BMCOptionKey',
} as const;

export interface BMCOptionKey {
  type: BMCOptionKeyType;
}

export interface BasketItemUpdateRequest {
  receiver: Receiver;
  sender: Sender;
  deliveryOption: DeliveryOptionSelection;
  serviceOptions?: ServiceOptionSelection[];
  customsDeclaration?: CustomsDeclaration;
  contentDescription?: string;
  isDefaultSender: boolean;
}

export type BasketValidationError = ContentDescriptionMissing | ContentDescriptionNotAllowed | ContentDescriptionTooLarge | CustomsDeclarationCertificateNumberTooLarge | CustomsDeclarationExportReasonMissing | CustomsDeclarationExportTypeMissing | CustomsDeclarationExtraRemarksTooLarge | CustomsDeclarationGoodsCodeInvalid | CustomsDeclarationGoodsCodeMissing | CustomsDeclarationGoodsDescriptionMissing | CustomsDeclarationGoodsDescriptionTooLarge | CustomsDeclarationInvoiceNumberTooLarge | CustomsDeclarationInvoiceTypeMissing | CustomsDeclarationMissing | CustomsDeclarationNotAllowed | CustomsDeclarationOriginMissing | CustomsDeclarationQuantityMissing | CustomsDeclarationValueMissing | CustomsDeclarationWeightMissing | DeliveryOptionMissing | DeliveryOptionNotAvailable | DiscountCodeInvalid | HandoverOptionMissing | InsuredValueOutOfRange | InvalidParcelTypeAmount | LabelTypeMissing | NoItemsInBasket | ParcelShopIsNotLastMile | ParcelTypesNotAvailable | PersonalNoteTooLong | ReceiverAddressNotInCorrectCountry | ReceiverAddressNotValid | ReceiverEmailAddressNotValid | ReceiverMissing | ReceiverNameTooLong | ReceiverPhoneNumberNotValid | ReferenceTooLong | SelectedDeliveryOptionIsExcluded | SelectedHandoverOptionExcluded | SelectedHandoverOptionNotAvailable | SelectedLabelTypeIsExcluded | SelectedLabelTypeNotAvailable | SelectedPickupWindowNotValid | SelectedServiceOptionIsExcluded | SenderAddressNotValid | SenderEmailAddressNotValid | SenderMissing | SenderNameTooLong | SenderPhoneNumberMissing | SenderPhoneNumberNotValid | SenderVatNumberNotValid | ServiceOptionNotAvailable | TooManyItemsInBasket;

export interface Brand {
  name: string;
}

export type Carrier = typeof Carrier[keyof typeof Carrier];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const Carrier = {
  DHL_EXPRESS: 'DHL_EXPRESS',
  DHL_PARCEL: 'DHL_PARCEL',
} as const;

export interface CarrierHandoverOptionsTypes {
  carrier: Carrier;
  handoverOptions?: HandoverOptionChoice[];
}

export interface CarrierLabelTypes {
  carrier: Carrier;
  labelTypes?: LabelTypeChoice[];
}

export interface ChangeHandoverOptionRequest {
  handover: HandoverOptionSelection;
}

export interface ChangeLabelTypeRequest {
  labelTypeKey: string;
}

export interface Conflict {
  message: string;
  errorId: string;
  type: 'Conflict';
}

export type ContentDescriptionMissingType = typeof ContentDescriptionMissingType[keyof typeof ContentDescriptionMissingType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ContentDescriptionMissingType = {
  ContentDescriptionMissing: 'ContentDescriptionMissing',
} as const;

export interface ContentDescriptionMissing {
  errorId: string;
  message: string;
  type: ContentDescriptionMissingType;
}

export type ContentDescriptionNotAllowedType = typeof ContentDescriptionNotAllowedType[keyof typeof ContentDescriptionNotAllowedType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ContentDescriptionNotAllowedType = {
  ContentDescriptionNotAllowed: 'ContentDescriptionNotAllowed',
} as const;

export interface ContentDescriptionNotAllowed {
  errorId: string;
  message: string;
  type: ContentDescriptionNotAllowedType;
}

export type ContentDescriptionTooLargeType = typeof ContentDescriptionTooLargeType[keyof typeof ContentDescriptionTooLargeType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ContentDescriptionTooLargeType = {
  ContentDescriptionTooLarge: 'ContentDescriptionTooLarge',
} as const;

export interface ContentDescriptionTooLarge {
  errorId: string;
  message: string;
  type: ContentDescriptionTooLargeType;
}

export type CreditCardType = typeof CreditCardType[keyof typeof CreditCardType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreditCardType = {
  CreditCard: 'CreditCard',
} as const;

export interface CreditCard {
  brands?: Brand[];
  type: CreditCardType;
}

export interface CustomsDeclaration {
  invoiceType?: InvoiceType;
  exportType?: ExportType;
  exportReason?: ExportReason;
  customsGoods?: CustomsGood[];
  extraRemarks?: string;
  licenseNumber?: string;
  certificateNumber?: string;
  invoiceNumber?: string;
}

export type CustomsDeclarationCertificateNumberTooLargeType = typeof CustomsDeclarationCertificateNumberTooLargeType[keyof typeof CustomsDeclarationCertificateNumberTooLargeType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CustomsDeclarationCertificateNumberTooLargeType = {
  CustomsDeclarationCertificateNumberTooLarge: 'CustomsDeclarationCertificateNumberTooLarge',
} as const;

export interface CustomsDeclarationCertificateNumberTooLarge {
  errorId: string;
  message: string;
  type: CustomsDeclarationCertificateNumberTooLargeType;
}

export type CustomsDeclarationExportReasonMissingType = typeof CustomsDeclarationExportReasonMissingType[keyof typeof CustomsDeclarationExportReasonMissingType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CustomsDeclarationExportReasonMissingType = {
  CustomsDeclarationExportReasonMissing: 'CustomsDeclarationExportReasonMissing',
} as const;

export interface CustomsDeclarationExportReasonMissing {
  errorId: string;
  message: string;
  type: CustomsDeclarationExportReasonMissingType;
}

export type CustomsDeclarationExportTypeMissingType = typeof CustomsDeclarationExportTypeMissingType[keyof typeof CustomsDeclarationExportTypeMissingType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CustomsDeclarationExportTypeMissingType = {
  CustomsDeclarationExportTypeMissing: 'CustomsDeclarationExportTypeMissing',
} as const;

export interface CustomsDeclarationExportTypeMissing {
  errorId: string;
  message: string;
  type: CustomsDeclarationExportTypeMissingType;
}

export type CustomsDeclarationExtraRemarksTooLargeType = typeof CustomsDeclarationExtraRemarksTooLargeType[keyof typeof CustomsDeclarationExtraRemarksTooLargeType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CustomsDeclarationExtraRemarksTooLargeType = {
  CustomsDeclarationExtraRemarksTooLarge: 'CustomsDeclarationExtraRemarksTooLarge',
} as const;

export interface CustomsDeclarationExtraRemarksTooLarge {
  errorId: string;
  message: string;
  type: CustomsDeclarationExtraRemarksTooLargeType;
}

export type CustomsDeclarationGoodsCodeInvalidType = typeof CustomsDeclarationGoodsCodeInvalidType[keyof typeof CustomsDeclarationGoodsCodeInvalidType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CustomsDeclarationGoodsCodeInvalidType = {
  CustomsDeclarationGoodsCodeInvalid: 'CustomsDeclarationGoodsCodeInvalid',
} as const;

export interface CustomsDeclarationGoodsCodeInvalid {
  errorId: string;
  message: string;
  type: CustomsDeclarationGoodsCodeInvalidType;
}

export type CustomsDeclarationGoodsCodeMissingType = typeof CustomsDeclarationGoodsCodeMissingType[keyof typeof CustomsDeclarationGoodsCodeMissingType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CustomsDeclarationGoodsCodeMissingType = {
  CustomsDeclarationGoodsCodeMissing: 'CustomsDeclarationGoodsCodeMissing',
} as const;

export interface CustomsDeclarationGoodsCodeMissing {
  errorId: string;
  message: string;
  type: CustomsDeclarationGoodsCodeMissingType;
}

export type CustomsDeclarationGoodsDescriptionMissingType = typeof CustomsDeclarationGoodsDescriptionMissingType[keyof typeof CustomsDeclarationGoodsDescriptionMissingType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CustomsDeclarationGoodsDescriptionMissingType = {
  CustomsDeclarationGoodsDescriptionMissing: 'CustomsDeclarationGoodsDescriptionMissing',
} as const;

export interface CustomsDeclarationGoodsDescriptionMissing {
  errorId: string;
  message: string;
  type: CustomsDeclarationGoodsDescriptionMissingType;
}

export type CustomsDeclarationGoodsDescriptionTooLargeType = typeof CustomsDeclarationGoodsDescriptionTooLargeType[keyof typeof CustomsDeclarationGoodsDescriptionTooLargeType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CustomsDeclarationGoodsDescriptionTooLargeType = {
  CustomsDeclarationGoodsDescriptionTooLarge: 'CustomsDeclarationGoodsDescriptionTooLarge',
} as const;

export interface CustomsDeclarationGoodsDescriptionTooLarge {
  errorId: string;
  message: string;
  type: CustomsDeclarationGoodsDescriptionTooLargeType;
}

export type CustomsDeclarationInvoiceNumberTooLargeType = typeof CustomsDeclarationInvoiceNumberTooLargeType[keyof typeof CustomsDeclarationInvoiceNumberTooLargeType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CustomsDeclarationInvoiceNumberTooLargeType = {
  CustomsDeclarationInvoiceNumberTooLarge: 'CustomsDeclarationInvoiceNumberTooLarge',
} as const;

export interface CustomsDeclarationInvoiceNumberTooLarge {
  errorId: string;
  message: string;
  type: CustomsDeclarationInvoiceNumberTooLargeType;
}

export type CustomsDeclarationInvoiceTypeMissingType = typeof CustomsDeclarationInvoiceTypeMissingType[keyof typeof CustomsDeclarationInvoiceTypeMissingType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CustomsDeclarationInvoiceTypeMissingType = {
  CustomsDeclarationInvoiceTypeMissing: 'CustomsDeclarationInvoiceTypeMissing',
} as const;

export interface CustomsDeclarationInvoiceTypeMissing {
  errorId: string;
  message: string;
  type: CustomsDeclarationInvoiceTypeMissingType;
}

export type CustomsDeclarationMissingType = typeof CustomsDeclarationMissingType[keyof typeof CustomsDeclarationMissingType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CustomsDeclarationMissingType = {
  CustomsDeclarationMissing: 'CustomsDeclarationMissing',
} as const;

export interface CustomsDeclarationMissing {
  errorId: string;
  message: string;
  type: CustomsDeclarationMissingType;
}

export type CustomsDeclarationNotAllowedType = typeof CustomsDeclarationNotAllowedType[keyof typeof CustomsDeclarationNotAllowedType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CustomsDeclarationNotAllowedType = {
  CustomsDeclarationNotAllowed: 'CustomsDeclarationNotAllowed',
} as const;

export interface CustomsDeclarationNotAllowed {
  errorId: string;
  message: string;
  type: CustomsDeclarationNotAllowedType;
}

export type CustomsDeclarationOriginMissingType = typeof CustomsDeclarationOriginMissingType[keyof typeof CustomsDeclarationOriginMissingType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CustomsDeclarationOriginMissingType = {
  CustomsDeclarationOriginMissing: 'CustomsDeclarationOriginMissing',
} as const;

export interface CustomsDeclarationOriginMissing {
  errorId: string;
  message: string;
  type: CustomsDeclarationOriginMissingType;
}

export type CustomsDeclarationQuantityMissingType = typeof CustomsDeclarationQuantityMissingType[keyof typeof CustomsDeclarationQuantityMissingType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CustomsDeclarationQuantityMissingType = {
  CustomsDeclarationQuantityMissing: 'CustomsDeclarationQuantityMissing',
} as const;

export interface CustomsDeclarationQuantityMissing {
  errorId: string;
  message: string;
  type: CustomsDeclarationQuantityMissingType;
}

export type CustomsDeclarationValueMissingType = typeof CustomsDeclarationValueMissingType[keyof typeof CustomsDeclarationValueMissingType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CustomsDeclarationValueMissingType = {
  CustomsDeclarationValueMissing: 'CustomsDeclarationValueMissing',
} as const;

export interface CustomsDeclarationValueMissing {
  errorId: string;
  message: string;
  type: CustomsDeclarationValueMissingType;
}

export type CustomsDeclarationWeightMissingType = typeof CustomsDeclarationWeightMissingType[keyof typeof CustomsDeclarationWeightMissingType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CustomsDeclarationWeightMissingType = {
  CustomsDeclarationWeightMissing: 'CustomsDeclarationWeightMissing',
} as const;

export interface CustomsDeclarationWeightMissing {
  errorId: string;
  message: string;
  type: CustomsDeclarationWeightMissingType;
}

export interface CustomsGood {
  description: string;
  code?: string;
  origin?: string;
  quantity?: number;
  value?: number;
  weight?: number;
}

export interface DecodingError {
  errorId: string;
  message: string;
  errors?: FieldError[];
  type: 'DecodingError';
}

export type DeliverAtServicePointType = typeof DeliverAtServicePointType[keyof typeof DeliverAtServicePointType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const DeliverAtServicePointType = {
  DeliverAtServicePoint: 'DeliverAtServicePoint',
} as const;

export interface DeliverAtServicePoint {
  servicePointKey: string;
  type: DeliverAtServicePointType;
}

export interface DeliverAtServicePointChoice {
  price: Price;
  excludes?: OptionKey[];
  implies?: OptionKey[];
  excludesImpliesKey: OptionKey;
  isExcludedBy?: OptionKey[];
  type: 'DeliverAtServicePoint';
}

export type DeliverAtServicePointOptionKeyType = typeof DeliverAtServicePointOptionKeyType[keyof typeof DeliverAtServicePointOptionKeyType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const DeliverAtServicePointOptionKeyType = {
  DeliverAtServicePointOptionKey: 'DeliverAtServicePointOptionKey',
} as const;

export interface DeliverAtServicePointOptionKey {
  type: DeliverAtServicePointOptionKeyType;
}

export type DeliverToDoorType = typeof DeliverToDoorType[keyof typeof DeliverToDoorType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const DeliverToDoorType = {
  DeliverToDoorChoice: 'DeliverToDoorChoice',
} as const;

export interface DeliverToDoor {
  type: DeliverToDoorType;
}

export interface DeliverToDoorChoice {
  price: Price;
  excludes?: OptionKey[];
  implies?: OptionKey[];
  excludesImpliesKey: OptionKey;
  isExcludedBy?: OptionKey[];
  type: 'DeliverToDoor';
}

export type DeliverToDoorOptionKeyType = typeof DeliverToDoorOptionKeyType[keyof typeof DeliverToDoorOptionKeyType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const DeliverToDoorOptionKeyType = {
  DeliverToDoorOptionKey: 'DeliverToDoorOptionKey',
} as const;

export interface DeliverToDoorOptionKey {
  type: DeliverToDoorOptionKeyType;
}

export const DeliveryBefore0900Value = {
  type: 'DeliveryBefore0900',
} as const;
export type DeliveryBefore0900 = typeof DeliveryBefore0900Value;

export interface DeliveryBefore0900Choice {
  price: Price;
  excludes?: OptionKey[];
  implies?: OptionKey[];
  excludesImpliesKey: OptionKey;
  isExcludedBy?: OptionKey[];
  type: 'DeliveryBefore0900';
}

export type DeliveryBefore0900OptionKeyType = typeof DeliveryBefore0900OptionKeyType[keyof typeof DeliveryBefore0900OptionKeyType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const DeliveryBefore0900OptionKeyType = {
  DeliveryBefore0900OptionKey: 'DeliveryBefore0900OptionKey',
} as const;

export interface DeliveryBefore0900OptionKey {
  type: DeliveryBefore0900OptionKeyType;
}

export const DeliveryBefore1030Value = {
  type: 'DeliveryBefore1030',
} as const;
export type DeliveryBefore1030 = typeof DeliveryBefore1030Value;

export interface DeliveryBefore1030Choice {
  price: Price;
  excludes?: OptionKey[];
  implies?: OptionKey[];
  excludesImpliesKey: OptionKey;
  isExcludedBy?: OptionKey[];
  type: 'DeliveryBefore1030';
}

export type DeliveryBefore1030OptionKeyType = typeof DeliveryBefore1030OptionKeyType[keyof typeof DeliveryBefore1030OptionKeyType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const DeliveryBefore1030OptionKeyType = {
  DeliveryBefore1030OptionKey: 'DeliveryBefore1030OptionKey',
} as const;

export interface DeliveryBefore1030OptionKey {
  type: DeliveryBefore1030OptionKeyType;
}

export const DeliveryBefore1200Value = {
  type: 'DeliveryBefore1200',
} as const;
export type DeliveryBefore1200 = typeof DeliveryBefore1200Value;

export interface DeliveryBefore1200Choice {
  price: Price;
  excludes?: OptionKey[];
  implies?: OptionKey[];
  excludesImpliesKey: OptionKey;
  isExcludedBy?: OptionKey[];
  type: 'DeliveryBefore1200';
}

export type DeliveryBefore1200OptionKeyType = typeof DeliveryBefore1200OptionKeyType[keyof typeof DeliveryBefore1200OptionKeyType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const DeliveryBefore1200OptionKeyType = {
  DeliveryBefore1200OptionKey: 'DeliveryBefore1200OptionKey',
} as const;

export interface DeliveryBefore1200OptionKey {
  type: DeliveryBefore1200OptionKeyType;
}

export const DeliveryBeforeEndOfWorkdayValue = {
  type: 'DeliveryBeforeEndOfWorkday',
} as const;
export type DeliveryBeforeEndOfWorkday = typeof DeliveryBeforeEndOfWorkdayValue;

export interface DeliveryBeforeEndOfWorkdayChoice {
  price: Price;
  excludes?: OptionKey[];
  implies?: OptionKey[];
  excludesImpliesKey: OptionKey;
  isExcludedBy?: OptionKey[];
  type: 'DeliveryBeforeEndOfWorkday';
}

export type DeliveryBeforeEndOfWorkdayOptionKeyType = typeof DeliveryBeforeEndOfWorkdayOptionKeyType[keyof typeof DeliveryBeforeEndOfWorkdayOptionKeyType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const DeliveryBeforeEndOfWorkdayOptionKeyType = {
  DeliveryBeforeEndOfWorkdayOptionKey: 'DeliveryBeforeEndOfWorkdayOptionKey',
} as const;

export interface DeliveryBeforeEndOfWorkdayOptionKey {
  type: DeliveryBeforeEndOfWorkdayOptionKeyType;
}

export type DeliveryOptionChoice = DeliverAtServicePointChoice | DeliverToDoorChoice | DeliveryBefore0900Choice | DeliveryBefore1030Choice | DeliveryBefore1200Choice | DeliveryBeforeEndOfWorkdayChoice;

export type DeliveryOptionMissingType = typeof DeliveryOptionMissingType[keyof typeof DeliveryOptionMissingType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const DeliveryOptionMissingType = {
  DeliveryOptionMissing: 'DeliveryOptionMissing',
} as const;

export interface DeliveryOptionMissing {
  errorId: string;
  message: string;
  type: DeliveryOptionMissingType;
}

export type DeliveryOptionNotAvailableType = typeof DeliveryOptionNotAvailableType[keyof typeof DeliveryOptionNotAvailableType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const DeliveryOptionNotAvailableType = {
  DeliveryOptionNotAvailable: 'DeliveryOptionNotAvailable',
} as const;

export interface DeliveryOptionNotAvailable {
  errorId: string;
  message: string;
  type: DeliveryOptionNotAvailableType;
}

export type DeliveryOptionSelection = DeliverAtServicePoint | DeliverToDoor | DeliveryBefore0900 | DeliveryBefore1030 | DeliveryBefore1200 | DeliveryBeforeEndOfWorkday;

export interface Dimensions {
  maxLength: number;
  maxWidth: number;
  maxHeight: number;
}

export interface Discount {
  code: string;
}

export type DiscountCodeInvalidType = typeof DiscountCodeInvalidType[keyof typeof DiscountCodeInvalidType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const DiscountCodeInvalidType = {
  DiscountCodeInvalid: 'DiscountCodeInvalid',
} as const;

export interface DiscountCodeInvalid {
  errorId: string;
  message: string;
  type: DiscountCodeInvalidType;
}

export interface DynamicPriceInsurance {
  insuredValue: number;
  type: 'DynamicPriceInsurance';
}

export interface DynamicPriceInsuranceChoice {
  price: Price;
  minimalPrice: Price;
  priceRate: number;
  userInputRequired: boolean;
  minInsuredValue: number;
  maxInsuredValue: number;
  excludes?: OptionKey[];
  implies?: OptionKey[];
  excludesImpliesKey: OptionKey;
  isExcludedBy?: OptionKey[];
  type: 'DynamicPriceInsurance';
}

export type DynamicPriceInsuranceOptionKeyType = typeof DynamicPriceInsuranceOptionKeyType[keyof typeof DynamicPriceInsuranceOptionKeyType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const DynamicPriceInsuranceOptionKeyType = {
  DynamicPriceInsuranceOptionKey: 'DynamicPriceInsuranceOptionKey',
} as const;

export interface DynamicPriceInsuranceOptionKey {
  type: DynamicPriceInsuranceOptionKeyType;
}

export interface ExpectedDeliveryDate {
  product: Product;
  toCountry: string;
  date: string;
}

export type ExportReason = typeof ExportReason[keyof typeof ExportReason];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ExportReason = {
  CommercialSample: 'CommercialSample',
  Documents: 'Documents',
  Gift: 'Gift',
  Other: 'Other',
  ReturnedGoods: 'ReturnedGoods',
  SaleOfGoods: 'SaleOfGoods',
} as const;

export type ExportType = typeof ExportType[keyof typeof ExportType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ExportType = {
  Permanent: 'Permanent',
  Repair: 'Repair',
  Return: 'Return',
  Temporary: 'Temporary',
} as const;

export const ExtendedLiabilityValue = {
  type: 'ExtendedLiability',
} as const;
export type ExtendedLiability = typeof ExtendedLiabilityValue;

export interface ExtendedLiabilityChoice {
  price: Price;
  maxInsuredValue: number;
  userInputRequired: boolean;
  excludes?: OptionKey[];
  implies?: OptionKey[];
  excludesImpliesKey: OptionKey;
  isExcludedBy?: OptionKey[];
  type: 'ExtendedLiability';
}

export type ExtendedLiabilityOptionKeyType = typeof ExtendedLiabilityOptionKeyType[keyof typeof ExtendedLiabilityOptionKeyType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ExtendedLiabilityOptionKeyType = {
  ExtendedLiabilityOptionKey: 'ExtendedLiabilityOptionKey',
} as const;

export interface ExtendedLiabilityOptionKey {
  type: ExtendedLiabilityOptionKeyType;
}

export interface FieldError {
  error: string;
  path?: string[];
}

export const FixedPriceInsuranceValue = {
  type: 'FixedPriceInsurance',
} as const;
export type FixedPriceInsurance = typeof FixedPriceInsuranceValue;

export interface FixedPriceInsuranceChoice {
  price: Price;
  userInputRequired: boolean;
  maxInsuredValue: number;
  excludes?: OptionKey[];
  implies?: OptionKey[];
  excludesImpliesKey: OptionKey;
  isExcludedBy?: OptionKey[];
  type: 'FixedPriceInsurance';
}

export type FixedPriceInsuranceOptionKeyType = typeof FixedPriceInsuranceOptionKeyType[keyof typeof FixedPriceInsuranceOptionKeyType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const FixedPriceInsuranceOptionKeyType = {
  FixedPriceInsuranceOptionKey: 'FixedPriceInsuranceOptionKey',
} as const;

export interface FixedPriceInsuranceOptionKey {
  type: FixedPriceInsuranceOptionKeyType;
}

export interface GetBasketItemResponse {
  id: string;
  carrier: Carrier;
  product: Product;
  parcelType: ParcelType;
  price: Price;
  priceWithDiscount?: Price;
  toCountry: string;
  createdAt: string;
  receiver?: Receiver;
  sender?: Sender;
  deliveryOption?: DeliveryOptionSelection;
  serviceOptions?: ServiceOptionSelection[];
  totalPrice: Price;
  totalPriceWithDiscount?: Price;
  discountCode?: string;
  discountPercent?: number;
  isCustomsDestination: boolean;
  hasEntrySummaryDeclaration: boolean;
  customsDeclaration?: CustomsDeclaration;
  isContentDescriptionRequired: boolean;
  contentDescription?: string;
  validations?: BasketValidationError[];
}

export interface GetBasketResponse {
  items?: GetBasketItemResponse[];
  totalPrice: Price;
  maxParcels: number;
}

export interface GetBasketSummaryResponse {
  numberOfItems: number;
  totalPrice?: Price;
}

export interface GetDeliveryOptionsBasketItemResponse {
  deliveryOptions?: DeliveryOptionChoice[];
}

export interface GetOrderResponse {
  orderId: string;
  total: Price;
  status: OrderStatus;
  sender: Sender;
  orderArtifacts: MapCarrierOptionOrderArtifact;
  orderLineSummary?: OrderLineSummary[];
  askForPrintlessPhoto: boolean;
  askLockerReservation: boolean;
}

export interface GetPaymentMethodsResponse {
  methods?: SupportedPaymentMethod[];
}

export interface GetServiceOptionsBasketItemResponse {
  serviceOptions?: ServiceOptionChoice[];
}

export interface HMacAuthToken {
  payload: string;
}

export type HandInAtServicePointType = typeof HandInAtServicePointType[keyof typeof HandInAtServicePointType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const HandInAtServicePointType = {
  HandInAtServicePoint: 'HandInAtServicePoint',
} as const;

export interface HandInAtServicePoint {
  type: HandInAtServicePointType;
}

export type HandInAtServicePointChoiceType = typeof HandInAtServicePointChoiceType[keyof typeof HandInAtServicePointChoiceType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const HandInAtServicePointChoiceType = {
  HandInAtServicePoint: 'HandInAtServicePoint',
} as const;

export interface HandInAtServicePointChoice {
  price: Price;
  excludes?: OptionKey[];
  implies?: OptionKey[];
  excludesImpliesKey: OptionKey;
  isExcludedBy?: OptionKey[];
  type: HandInAtServicePointChoiceType;
}

export type HandInAtServicePointOptionKeyType = typeof HandInAtServicePointOptionKeyType[keyof typeof HandInAtServicePointOptionKeyType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const HandInAtServicePointOptionKeyType = {
  HandInAtServicePointOptionKey: 'HandInAtServicePointOptionKey',
} as const;

export interface HandInAtServicePointOptionKey {
  type: HandInAtServicePointOptionKeyType;
}

export type HandoverOptionChoice = HandInAtServicePointChoice | PickupByCarrierChoice;

export type HandoverOptionMissingType = typeof HandoverOptionMissingType[keyof typeof HandoverOptionMissingType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const HandoverOptionMissingType = {
  HandoverOptionMissing: 'HandoverOptionMissing',
} as const;

export interface HandoverOptionMissing {
  errorId: string;
  message: string;
  type: HandoverOptionMissingType;
}

export type HandoverOptionSelection = HandInAtServicePoint | PickupByCarrier;

export type IdealType = typeof IdealType[keyof typeof IdealType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const IdealType = {
  Ideal: 'Ideal',
} as const;

export interface Ideal {
  type: IdealType;
}

export type InsuredValueOutOfRangeType = typeof InsuredValueOutOfRangeType[keyof typeof InsuredValueOutOfRangeType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const InsuredValueOutOfRangeType = {
  InsuredValueOutOfRange: 'InsuredValueOutOfRange',
} as const;

export interface InsuredValueOutOfRange {
  errorId: string;
  message: string;
  type: InsuredValueOutOfRangeType;
}

export type InvalidParcelTypeAmountType = typeof InvalidParcelTypeAmountType[keyof typeof InvalidParcelTypeAmountType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const InvalidParcelTypeAmountType = {
  InvalidParcelTypeAmount: 'InvalidParcelTypeAmount',
} as const;

export interface InvalidParcelTypeAmount {
  errorId: string;
  message: string;
  type: InvalidParcelTypeAmountType;
}

export interface Invoice {
  url: string;
}

export type InvoiceType = typeof InvoiceType[keyof typeof InvoiceType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const InvoiceType = {
  Commercial: 'Commercial',
  NonCommercial: 'NonCommercial',
} as const;

export interface Label {
  labelType: LabelType;
  url: string;
}

export type LabelType = typeof LabelType[keyof typeof LabelType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const LabelType = {
  Print: 'Print',
  Printless: 'Printless',
} as const;

export type LabelTypeChoice = PrintChoice | PrintlessChoice;

export type LabelTypeMissingType = typeof LabelTypeMissingType[keyof typeof LabelTypeMissingType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const LabelTypeMissingType = {
  LabelTypeMissing: 'LabelTypeMissing',
} as const;

export interface LabelTypeMissing {
  errorId: string;
  message: string;
  type: LabelTypeMissingType;
}

export type LockerSize = typeof LockerSize[keyof typeof LockerSize];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const LockerSize = {
  extra_extra_large: 'extra_extra_large',
  extra_large: 'extra_large',
  extra_small: 'extra_small',
  large: 'large',
  medium: 'medium',
  small: 'small',
} as const;

export interface MapCarrierOptionOrderArtifact {[key: string]: OrderArtifact}

export type NoItemsInBasketType = typeof NoItemsInBasketType[keyof typeof NoItemsInBasketType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const NoItemsInBasketType = {
  NoItemsInBasket: 'NoItemsInBasket',
} as const;

export interface NoItemsInBasket {
  errorId: string;
  message: string;
  type: NoItemsInBasketType;
}

export interface NotFound {
  message: string;
  errorId: string;
  type: 'NotFound';
}

export interface NotFound1 {
  message: string;
  errorId: string;
  type: 'NotFound';
}

export type NotToNeighboursType = typeof NotToNeighboursType[keyof typeof NotToNeighboursType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const NotToNeighboursType = {
  NotToNeighboursChoice: 'NotToNeighboursChoice',
  NotToNeighbours: 'NotToNeighbours',
} as const;

export interface NotToNeighbours {
  type: NotToNeighboursType;
}

export interface NotToNeighboursChoice {
  price: Price;
  userInputRequired: boolean;
  excludes?: OptionKey[];
  implies?: OptionKey[];
  excludesImpliesKey: OptionKey;
  isExcludedBy?: OptionKey[];
  type: 'NotToNeighbours';
}

export type NotToNeighboursOptionKeyType = typeof NotToNeighboursOptionKeyType[keyof typeof NotToNeighboursOptionKeyType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const NotToNeighboursOptionKeyType = {
  NotToNeighboursOptionKey: 'NotToNeighboursOptionKey',
} as const;

export interface NotToNeighboursOptionKey {
  type: NotToNeighboursOptionKeyType;
}

export type OptionKey = AGTOptionKey | BMCOptionKey | DeliverAtServicePointOptionKey | DeliverToDoorOptionKey | DeliveryBefore0900OptionKey | DeliveryBefore1030OptionKey | DeliveryBefore1200OptionKey | DeliveryBeforeEndOfWorkdayOptionKey | DynamicPriceInsuranceOptionKey | ExtendedLiabilityOptionKey | FixedPriceInsuranceOptionKey | HandInAtServicePointOptionKey | NotToNeighboursOptionKey | PersonalNoteOptionKey | PickupByCarrierOptionKey | PrintOptionKey | PrintlessOptionKey | ReferenceOptionKey;

export interface OrderArtifact {
  label: Label;
  invoice: Invoice;
}

export interface OrderCreationFailed {
  errorId: string;
  validations?: BasketValidationError[];
  type: 'OrderCreationFailed';
}

export interface OrderLineSummary {
  orderLineId: string;
  parcelType: ParcelType;
  product: Product;
  fulfilledByCarrier: Carrier;
  price: Price;
  receiver: Receiver;
  deliveryOption: DeliveryOptionSelection;
  handoverOption: HandoverOptionSelection;
  serviceOptions?: ServiceOptionSelection[];
  discount?: Discount;
}

export type OrderStatus = typeof OrderStatus[keyof typeof OrderStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const OrderStatus = {
  Cancelled: 'Cancelled',
  Initial: 'Initial',
  Pending: 'Pending',
  Succeeded: 'Succeeded',
} as const;

export type ParcelShopIsNotLastMileType = typeof ParcelShopIsNotLastMileType[keyof typeof ParcelShopIsNotLastMileType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ParcelShopIsNotLastMileType = {
  ParcelShopIsNotLastMile: 'ParcelShopIsNotLastMile',
} as const;

export interface ParcelShopIsNotLastMile {
  errorId: string;
  message: string;
  type: ParcelShopIsNotLastMileType;
}

export interface ParcelType {
  key: string;
  definition: ParcelTypeDefinition;
}

export interface ParcelTypeDefinition {
  maxWeight: number;
  dimensions: Dimensions;
  price: Price;
}

export interface ParcelTypeSelection {
  key: string;
  amount: number;
}

export type ParcelTypesNotAvailableType = typeof ParcelTypesNotAvailableType[keyof typeof ParcelTypesNotAvailableType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ParcelTypesNotAvailableType = {
  ParcelTypesNotAvailable: 'ParcelTypesNotAvailable',
} as const;

export interface ParcelTypesNotAvailable {
  errorId: string;
  message: string;
  type: ParcelTypesNotAvailableType;
}

export interface PaymentUrlNotValid {
  errorId: string;
  message: string;
  type: 'PaymentUrlNotValid';
}

export interface PersonalNote {
  note: string;
  type: 'PersonalNote';
}

export interface PersonalNoteChoice {
  price: Price;
  userInputRequired: boolean;
  excludes?: OptionKey[];
  implies?: OptionKey[];
  excludesImpliesKey: OptionKey;
  isExcludedBy?: OptionKey[];
  type: 'PersonalNote';
}

export type PersonalNoteOptionKeyType = typeof PersonalNoteOptionKeyType[keyof typeof PersonalNoteOptionKeyType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PersonalNoteOptionKeyType = {
  PersonalNoteOptionKey: 'PersonalNoteOptionKey',
} as const;

export interface PersonalNoteOptionKey {
  type: PersonalNoteOptionKeyType;
}

export type PersonalNoteTooLongType = typeof PersonalNoteTooLongType[keyof typeof PersonalNoteTooLongType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PersonalNoteTooLongType = {
  PersonalNoteTooLong: 'PersonalNoteTooLong',
} as const;

export interface PersonalNoteTooLong {
  errorId: string;
  message: string;
  type: PersonalNoteTooLongType;
}

export type PickupByCarrierType = typeof PickupByCarrierType[keyof typeof PickupByCarrierType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PickupByCarrierType = {
  PickupByCarrier: 'PickupByCarrier',
} as const;

export interface PickupByCarrier {
  pickupWindow: PickupWindow;
  type: PickupByCarrierType;
}

export type PickupByCarrierChoiceType = typeof PickupByCarrierChoiceType[keyof typeof PickupByCarrierChoiceType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PickupByCarrierChoiceType = {
  PickupByCarrier: 'PickupByCarrier',
} as const;

export interface PickupByCarrierChoice {
  price: Price;
  pickupWindows?: PickupWindowRange[];
  excludes?: OptionKey[];
  implies?: OptionKey[];
  excludesImpliesKey: OptionKey;
  isExcludedBy?: OptionKey[];
  type: PickupByCarrierChoiceType;
}

export type PickupByCarrierOptionKeyType = typeof PickupByCarrierOptionKeyType[keyof typeof PickupByCarrierOptionKeyType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PickupByCarrierOptionKeyType = {
  PickupByCarrierOptionKey: 'PickupByCarrierOptionKey',
} as const;

export interface PickupByCarrierOptionKey {
  type: PickupByCarrierOptionKeyType;
}

export interface PickupWindow {
  date: string;
  pickupEarliest: string;
  pickupLatest: string;
  timezone: string;
}

export interface PickupWindowRange {
  date: string;
  pickupEarliest: string;
  pickupLatest: string;
  cutoffTime: string;
  timezone: string;
  minimalWindowTime: number;
  expectedDeliveryDates?: ExpectedDeliveryDate[];
}

export interface Price {
  currency: string;
  withTax: number;
  withoutTax: number;
  vatRate?: number;
}

export type PrintChoiceType = typeof PrintChoiceType[keyof typeof PrintChoiceType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PrintChoiceType = {
  Print: 'Print',
} as const;

export interface PrintChoice {
  price: Price;
  excludes?: OptionKey[];
  implies?: OptionKey[];
  excludesImpliesKey: OptionKey;
  isExcludedBy?: OptionKey[];
  type: PrintChoiceType;
}

export type PrintOptionKeyType = typeof PrintOptionKeyType[keyof typeof PrintOptionKeyType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PrintOptionKeyType = {
  PrintOptionKey: 'PrintOptionKey',
} as const;

export interface PrintOptionKey {
  type: PrintOptionKeyType;
}

export type PrintlessChoiceType = typeof PrintlessChoiceType[keyof typeof PrintlessChoiceType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PrintlessChoiceType = {
  Printless: 'Printless',
} as const;

export interface PrintlessChoice {
  price: Price;
  excludes?: OptionKey[];
  implies?: OptionKey[];
  excludesImpliesKey: OptionKey;
  isExcludedBy?: OptionKey[];
  type: PrintlessChoiceType;
}

export type PrintlessOptionKeyType = typeof PrintlessOptionKeyType[keyof typeof PrintlessOptionKeyType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PrintlessOptionKeyType = {
  PrintlessOptionKey: 'PrintlessOptionKey',
} as const;

export interface PrintlessOptionKey {
  type: PrintlessOptionKeyType;
}

export type Product = typeof Product[keyof typeof Product];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const Product = {
  Economy: 'Economy',
  Fast: 'Fast',
  Standard: 'Standard',
} as const;

export interface ProductResponse {
  product: Product;
  fulfilledByCarrier: Carrier;
  fromPrice: Price;
  fastestTransitDays: number;
}

export interface ProductsResponse {
  products?: ProductResponse[];
  defaultProduct: Product;
}

export interface Receiver {
  firstName: string;
  lastName: string;
  companyName?: string;
  postalCode: string;
  houseNumber: string;
  street: string;
  houseNumberAddition?: string;
  extraAddressInformation?: string;
  emailAddress: string;
  phoneNumber?: string;
  country?: string;
  city: string;
}

export type ReceiverAddressNotInCorrectCountryType = typeof ReceiverAddressNotInCorrectCountryType[keyof typeof ReceiverAddressNotInCorrectCountryType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ReceiverAddressNotInCorrectCountryType = {
  ReceiverAddressNotInCorrectCountry: 'ReceiverAddressNotInCorrectCountry',
} as const;

export interface ReceiverAddressNotInCorrectCountry {
  errorId: string;
  message: string;
  type: ReceiverAddressNotInCorrectCountryType;
}

export type ReceiverAddressNotValidType = typeof ReceiverAddressNotValidType[keyof typeof ReceiverAddressNotValidType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ReceiverAddressNotValidType = {
  ReceiverAddressNotValid: 'ReceiverAddressNotValid',
} as const;

export interface ReceiverAddressNotValid {
  errorId: string;
  message: string;
  type: ReceiverAddressNotValidType;
}

export type ReceiverEmailAddressNotValidType = typeof ReceiverEmailAddressNotValidType[keyof typeof ReceiverEmailAddressNotValidType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ReceiverEmailAddressNotValidType = {
  ReceiverEmailAddressNotValid: 'ReceiverEmailAddressNotValid',
} as const;

export interface ReceiverEmailAddressNotValid {
  errorId: string;
  message: string;
  type: ReceiverEmailAddressNotValidType;
}

export type ReceiverMissingType = typeof ReceiverMissingType[keyof typeof ReceiverMissingType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ReceiverMissingType = {
  ReceiverMissing: 'ReceiverMissing',
} as const;

export interface ReceiverMissing {
  errorId: string;
  message: string;
  type: ReceiverMissingType;
}

export type ReceiverNameTooLongType = typeof ReceiverNameTooLongType[keyof typeof ReceiverNameTooLongType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ReceiverNameTooLongType = {
  ReceiverNameTooLong: 'ReceiverNameTooLong',
} as const;

export interface ReceiverNameTooLong {
  errorId: string;
  message: string;
  type: ReceiverNameTooLongType;
}

export type ReceiverPhoneNumberNotValidType = typeof ReceiverPhoneNumberNotValidType[keyof typeof ReceiverPhoneNumberNotValidType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ReceiverPhoneNumberNotValidType = {
  ReceiverPhoneNumberNotValid: 'ReceiverPhoneNumberNotValid',
} as const;

export interface ReceiverPhoneNumberNotValid {
  errorId: string;
  message: string;
  type: ReceiverPhoneNumberNotValidType;
}

export interface Reference {
  reference: string;
  type: 'Reference';
}

export interface ReferenceChoice {
  price: Price;
  userInputRequired: boolean;
  excludes?: OptionKey[];
  implies?: OptionKey[];
  excludesImpliesKey: OptionKey;
  isExcludedBy?: OptionKey[];
  type: 'Reference';
}

export type ReferenceOptionKeyType = typeof ReferenceOptionKeyType[keyof typeof ReferenceOptionKeyType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ReferenceOptionKeyType = {
  ReferenceOptionKey: 'ReferenceOptionKey',
} as const;

export interface ReferenceOptionKey {
  type: ReferenceOptionKeyType;
}

export type ReferenceTooLongType = typeof ReferenceTooLongType[keyof typeof ReferenceTooLongType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ReferenceTooLongType = {
  ReferenceTooLong: 'ReferenceTooLong',
} as const;

export interface ReferenceTooLong {
  errorId: string;
  message: string;
  type: ReferenceTooLongType;
}

export interface ReserveLockerRequest {
  servicePointId: string;
  lockerSize: LockerSize;
}

export type SelectedDeliveryOptionIsExcludedType = typeof SelectedDeliveryOptionIsExcludedType[keyof typeof SelectedDeliveryOptionIsExcludedType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SelectedDeliveryOptionIsExcludedType = {
  SelectedDeliveryOptionIsExcluded: 'SelectedDeliveryOptionIsExcluded',
} as const;

export interface SelectedDeliveryOptionIsExcluded {
  errorId: string;
  message: string;
  type: SelectedDeliveryOptionIsExcludedType;
}

export type SelectedHandoverOptionExcludedType = typeof SelectedHandoverOptionExcludedType[keyof typeof SelectedHandoverOptionExcludedType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SelectedHandoverOptionExcludedType = {
  SelectedHandoverOptionExcluded: 'SelectedHandoverOptionExcluded',
} as const;

export interface SelectedHandoverOptionExcluded {
  errorId: string;
  message: string;
  type: SelectedHandoverOptionExcludedType;
}

export type SelectedHandoverOptionNotAvailableType = typeof SelectedHandoverOptionNotAvailableType[keyof typeof SelectedHandoverOptionNotAvailableType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SelectedHandoverOptionNotAvailableType = {
  SelectedHandoverOptionNotAvailable: 'SelectedHandoverOptionNotAvailable',
} as const;

export interface SelectedHandoverOptionNotAvailable {
  errorId: string;
  message: string;
  type: SelectedHandoverOptionNotAvailableType;
}

export type SelectedLabelTypeIsExcludedType = typeof SelectedLabelTypeIsExcludedType[keyof typeof SelectedLabelTypeIsExcludedType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SelectedLabelTypeIsExcludedType = {
  SelectedLabelTypeIsExcluded: 'SelectedLabelTypeIsExcluded',
} as const;

export interface SelectedLabelTypeIsExcluded {
  errorId: string;
  message: string;
  type: SelectedLabelTypeIsExcludedType;
}

export type SelectedLabelTypeNotAvailableType = typeof SelectedLabelTypeNotAvailableType[keyof typeof SelectedLabelTypeNotAvailableType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SelectedLabelTypeNotAvailableType = {
  SelectedLabelTypeNotAvailable: 'SelectedLabelTypeNotAvailable',
} as const;

export interface SelectedLabelTypeNotAvailable {
  errorId: string;
  message: string;
  type: SelectedLabelTypeNotAvailableType;
}

export type SelectedPickupWindowNotValidType = typeof SelectedPickupWindowNotValidType[keyof typeof SelectedPickupWindowNotValidType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SelectedPickupWindowNotValidType = {
  SelectedPickupWindowNotValid: 'SelectedPickupWindowNotValid',
} as const;

export interface SelectedPickupWindowNotValid {
  errorId: string;
  message: string;
  type: SelectedPickupWindowNotValidType;
}

export type SelectedServiceOptionIsExcludedType = typeof SelectedServiceOptionIsExcludedType[keyof typeof SelectedServiceOptionIsExcludedType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SelectedServiceOptionIsExcludedType = {
  SelectedServiceOptionIsExcluded: 'SelectedServiceOptionIsExcluded',
} as const;

export interface SelectedServiceOptionIsExcluded {
  errorId: string;
  message: string;
  type: SelectedServiceOptionIsExcludedType;
}

export interface Sender {
  firstName: string;
  lastName: string;
  companyName?: string;
  postalCode: string;
  houseNumber: string;
  street: string;
  houseNumberAddition?: string;
  extraAddressInformation?: string;
  emailAddress: string;
  phoneNumber?: string;
  country?: string;
  city: string;
  vatNumber?: string;
}

export type SenderAddressNotValidType = typeof SenderAddressNotValidType[keyof typeof SenderAddressNotValidType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SenderAddressNotValidType = {
  SenderAddressNotValid: 'SenderAddressNotValid',
} as const;

export interface SenderAddressNotValid {
  errorId: string;
  message: string;
  type: SenderAddressNotValidType;
}

export type SenderEmailAddressNotValidType = typeof SenderEmailAddressNotValidType[keyof typeof SenderEmailAddressNotValidType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SenderEmailAddressNotValidType = {
  SenderEmailAddressNotValid: 'SenderEmailAddressNotValid',
} as const;

export interface SenderEmailAddressNotValid {
  errorId: string;
  message: string;
  type: SenderEmailAddressNotValidType;
}

export type SenderMissingType = typeof SenderMissingType[keyof typeof SenderMissingType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SenderMissingType = {
  SenderMissing: 'SenderMissing',
} as const;

export interface SenderMissing {
  errorId: string;
  message: string;
  type: SenderMissingType;
}

export type SenderNameTooLongType = typeof SenderNameTooLongType[keyof typeof SenderNameTooLongType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SenderNameTooLongType = {
  SenderNameTooLong: 'SenderNameTooLong',
} as const;

export interface SenderNameTooLong {
  errorId: string;
  message: string;
  type: SenderNameTooLongType;
}

export type SenderPhoneNumberMissingType = typeof SenderPhoneNumberMissingType[keyof typeof SenderPhoneNumberMissingType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SenderPhoneNumberMissingType = {
  SenderPhoneNumberMissing: 'SenderPhoneNumberMissing',
} as const;

export interface SenderPhoneNumberMissing {
  errorId: string;
  message: string;
  type: SenderPhoneNumberMissingType;
}

export type SenderPhoneNumberNotValidType = typeof SenderPhoneNumberNotValidType[keyof typeof SenderPhoneNumberNotValidType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SenderPhoneNumberNotValidType = {
  SenderPhoneNumberNotValid: 'SenderPhoneNumberNotValid',
} as const;

export interface SenderPhoneNumberNotValid {
  errorId: string;
  message: string;
  type: SenderPhoneNumberNotValidType;
}

export type SenderVatNumberNotValidType = typeof SenderVatNumberNotValidType[keyof typeof SenderVatNumberNotValidType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SenderVatNumberNotValidType = {
  SenderVatNumberNotValid: 'SenderVatNumberNotValid',
} as const;

export interface SenderVatNumberNotValid {
  errorId: string;
  message: string;
  type: SenderVatNumberNotValidType;
}

export type ServiceOptionChoice = AGTChoice | BMCChoice | DynamicPriceInsuranceChoice | ExtendedLiabilityChoice | FixedPriceInsuranceChoice | NotToNeighboursChoice | PersonalNoteChoice | ReferenceChoice;

export type ServiceOptionNotAvailableType = typeof ServiceOptionNotAvailableType[keyof typeof ServiceOptionNotAvailableType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ServiceOptionNotAvailableType = {
  ServiceOptionNotAvailable: 'ServiceOptionNotAvailable',
} as const;

export interface ServiceOptionNotAvailable {
  errorId: string;
  message: string;
  type: ServiceOptionNotAvailableType;
}

export type ServiceOptionSelection = Agt | Bmc | DynamicPriceInsurance | ExtendedLiability | FixedPriceInsurance | NotToNeighbours | PersonalNote | Reference;

export interface StartPaymentRequest {
  returnUrl: string;
  cancelUrl: string;
  /** A IETF BCP 47 locale string */
  userLocale: string;
  receiveMarketingNotifications?: boolean;
  /** Platform identifier */
  platform: string;
}

export interface StartPaymentResponse {
  paymentUrl: string;
}

export type SupportedPaymentMethod = CreditCard | Ideal | Swish;

export type SwishType = typeof SwishType[keyof typeof SwishType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SwishType = {
  Swish: 'Swish',
} as const;

export interface Swish {
  type: SwishType;
}

export interface ToCountriesResponse {
  countries?: string[];
  default: string;
}

export type TooManyItemsInBasketType = typeof TooManyItemsInBasketType[keyof typeof TooManyItemsInBasketType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TooManyItemsInBasketType = {
  TooManyItemsInBasket: 'TooManyItemsInBasket',
} as const;

export interface TooManyItemsInBasket {
  errorId: string;
  message: string;
  type: TooManyItemsInBasketType;
}

export interface UnexpectedError {
  errorId: string;
  message: string;
  type: 'UnexpectedError';
}

export interface UnexpectedError1 {
  errorId: string;
  message: string;
  type: 'UnexpectedError';
}

export interface VerifyDiscountCodeForBasketRequest {
  discountCode: string;
}

export interface VerifyDiscountCodeForBasketResponse {
  basketItemIds?: string[];
  discountCode: string;
  discountPercent: number;
}

export type AddItemSelectionToBasket400 = BasketValidationError | DecodingError;

export type ChangeHandover400 = BasketValidationError | DecodingError;

export type DeleteHandover400 = BasketValidationError | DecodingError;

export type ChangeLabelType400 = BasketValidationError | DecodingError;

export type DeleteLabelType400 = BasketValidationError | DecodingError;

export type GetHandoverOptionsForBasketParams = {
/**
 * An optional postal code for the sender. If none is provided, we fetch the handover options for the entire country
 */
senderPostalCode?: string;
/**
 * An optional postal code for the receiver. If none is provided, we fetch the handover options for the entire country
 */
receiverPostalCode?: string;
};

export type VerifyDiscountCodeForBasket400 = BasketValidationError | DecodingError;

export type UpdateItemInBasket400 = BasketValidationError | DecodingError;

export type GetDeliveryOptionsForBasketItemParams = {
/**
 * An optional postal code for the sender. If none is provided, we fetch the delivery options for the entire country
 */
senderPostalCode?: string;
/**
 * An optional postal code for the receiver. If none is provided, we fetch the delivery options for the entire country
 */
receiverPostalCode?: string;
};

export type GetServiceOptionsForBasketItemParams = {
/**
 * An optional postal code for the sender. If none is provided, we fetch the delivery options for the entire country
 */
senderPostalCode?: string;
/**
 * An optional postal code for the receiver. If none is provided, we fetch the delivery options for the entire country
 */
receiverPostalCode?: string;
};

export type AddDiscountCodeToBasketItem400 = BasketValidationError | DecodingError;

export type StartPaymentPost400 = PaymentUrlNotValid | DecodingError;

export const useCountriesHook = () => {
        const countries = useMutator<ToCountriesResponse>();

        return useCallback((
    
 signal?: AbortSignal
) => {
        return countries(
          {url: `/consumer-sender-services/countries`, method: 'GET', signal
    },
          );
        }, [countries])
      }
    

export const getCountriesQueryKey = () => {
    return [`/consumer-sender-services/countries`] as const;
    }

    
export const useCountriesQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useCountriesHook>>>, TError = DecodingError | AuthenticationError | UnexpectedError>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useCountriesHook>>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCountriesQueryKey();

  const countries =  useCountriesHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useCountriesHook>>>> = ({ signal }) => countries(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useCountriesHook>>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type CountriesQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useCountriesHook>>>>
export type CountriesQueryError = DecodingError | AuthenticationError | UnexpectedError


export function useCountries<TData = Awaited<ReturnType<ReturnType<typeof useCountriesHook>>>, TError = DecodingError | AuthenticationError | UnexpectedError>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useCountriesHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useCountriesHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useCountriesHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCountries<TData = Awaited<ReturnType<ReturnType<typeof useCountriesHook>>>, TError = DecodingError | AuthenticationError | UnexpectedError>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useCountriesHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useCountriesHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useCountriesHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCountries<TData = Awaited<ReturnType<ReturnType<typeof useCountriesHook>>>, TError = DecodingError | AuthenticationError | UnexpectedError>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useCountriesHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useCountries<TData = Awaited<ReturnType<ReturnType<typeof useCountriesHook>>>, TError = DecodingError | AuthenticationError | UnexpectedError>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useCountriesHook>>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useCountriesQueryOptions(options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const useProductsHook = () => {
        const products = useMutator<ProductsResponse>();

        return useCallback((
    destinationCountryCode: string,
 signal?: AbortSignal
) => {
        return products(
          {url: `/consumer-sender-services/countries/${destinationCountryCode}/products`, method: 'GET', signal
    },
          );
        }, [products])
      }
    

export const getProductsQueryKey = (destinationCountryCode?: string,) => {
    return [`/consumer-sender-services/countries/${destinationCountryCode}/products`] as const;
    }

    
export const useProductsQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useProductsHook>>>, TError = DecodingError | AuthenticationError | UnexpectedError>(destinationCountryCode: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useProductsHook>>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getProductsQueryKey(destinationCountryCode);

  const products =  useProductsHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useProductsHook>>>> = ({ signal }) => products(destinationCountryCode, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(destinationCountryCode), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useProductsHook>>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ProductsQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useProductsHook>>>>
export type ProductsQueryError = DecodingError | AuthenticationError | UnexpectedError


export function useProducts<TData = Awaited<ReturnType<ReturnType<typeof useProductsHook>>>, TError = DecodingError | AuthenticationError | UnexpectedError>(
 destinationCountryCode: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useProductsHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useProductsHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useProductsHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useProducts<TData = Awaited<ReturnType<ReturnType<typeof useProductsHook>>>, TError = DecodingError | AuthenticationError | UnexpectedError>(
 destinationCountryCode: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useProductsHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useProductsHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useProductsHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useProducts<TData = Awaited<ReturnType<ReturnType<typeof useProductsHook>>>, TError = DecodingError | AuthenticationError | UnexpectedError>(
 destinationCountryCode: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useProductsHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useProducts<TData = Awaited<ReturnType<ReturnType<typeof useProductsHook>>>, TError = DecodingError | AuthenticationError | UnexpectedError>(
 destinationCountryCode: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useProductsHook>>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useProductsQueryOptions(destinationCountryCode,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const useParcelTypesHook = () => {
        const parcelTypes = useMutator<ParcelType[]>();

        return useCallback((
    destinationCountryCode: string,
    product: string,
 signal?: AbortSignal
) => {
        return parcelTypes(
          {url: `/consumer-sender-services/countries/${destinationCountryCode}/products/${product}/parcel-types`, method: 'GET', signal
    },
          );
        }, [parcelTypes])
      }
    

export const getParcelTypesQueryKey = (destinationCountryCode?: string,
    product?: string,) => {
    return [`/consumer-sender-services/countries/${destinationCountryCode}/products/${product}/parcel-types`] as const;
    }

    
export const useParcelTypesQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useParcelTypesHook>>>, TError = DecodingError | AuthenticationError | UnexpectedError>(destinationCountryCode: string,
    product: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useParcelTypesHook>>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getParcelTypesQueryKey(destinationCountryCode,product);

  const parcelTypes =  useParcelTypesHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useParcelTypesHook>>>> = ({ signal }) => parcelTypes(destinationCountryCode,product, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(destinationCountryCode && product), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useParcelTypesHook>>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ParcelTypesQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useParcelTypesHook>>>>
export type ParcelTypesQueryError = DecodingError | AuthenticationError | UnexpectedError


export function useParcelTypes<TData = Awaited<ReturnType<ReturnType<typeof useParcelTypesHook>>>, TError = DecodingError | AuthenticationError | UnexpectedError>(
 destinationCountryCode: string,
    product: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useParcelTypesHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useParcelTypesHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useParcelTypesHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useParcelTypes<TData = Awaited<ReturnType<ReturnType<typeof useParcelTypesHook>>>, TError = DecodingError | AuthenticationError | UnexpectedError>(
 destinationCountryCode: string,
    product: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useParcelTypesHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useParcelTypesHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useParcelTypesHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useParcelTypes<TData = Awaited<ReturnType<ReturnType<typeof useParcelTypesHook>>>, TError = DecodingError | AuthenticationError | UnexpectedError>(
 destinationCountryCode: string,
    product: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useParcelTypesHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useParcelTypes<TData = Awaited<ReturnType<ReturnType<typeof useParcelTypesHook>>>, TError = DecodingError | AuthenticationError | UnexpectedError>(
 destinationCountryCode: string,
    product: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useParcelTypesHook>>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useParcelTypesQueryOptions(destinationCountryCode,product,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Returns a summary of the current basket for the user
 */
export const useGetBasketSummaryHook = () => {
        const getBasketSummary = useMutator<GetBasketSummaryResponse>();

        return useCallback((
    
 signal?: AbortSignal
) => {
        return getBasketSummary(
          {url: `/consumer-sender-services/basket/summary`, method: 'GET', signal
    },
          );
        }, [getBasketSummary])
      }
    

export const getGetBasketSummaryQueryKey = () => {
    return [`/consumer-sender-services/basket/summary`] as const;
    }

    
export const useGetBasketSummaryQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetBasketSummaryHook>>>, TError = DecodingError | AuthenticationError | UnexpectedError>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetBasketSummaryHook>>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetBasketSummaryQueryKey();

  const getBasketSummary =  useGetBasketSummaryHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetBasketSummaryHook>>>> = ({ signal }) => getBasketSummary(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetBasketSummaryHook>>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetBasketSummaryQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetBasketSummaryHook>>>>
export type GetBasketSummaryQueryError = DecodingError | AuthenticationError | UnexpectedError


export function useGetBasketSummary<TData = Awaited<ReturnType<ReturnType<typeof useGetBasketSummaryHook>>>, TError = DecodingError | AuthenticationError | UnexpectedError>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetBasketSummaryHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetBasketSummaryHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetBasketSummaryHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBasketSummary<TData = Awaited<ReturnType<ReturnType<typeof useGetBasketSummaryHook>>>, TError = DecodingError | AuthenticationError | UnexpectedError>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetBasketSummaryHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetBasketSummaryHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetBasketSummaryHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBasketSummary<TData = Awaited<ReturnType<ReturnType<typeof useGetBasketSummaryHook>>>, TError = DecodingError | AuthenticationError | UnexpectedError>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetBasketSummaryHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetBasketSummary<TData = Awaited<ReturnType<ReturnType<typeof useGetBasketSummaryHook>>>, TError = DecodingError | AuthenticationError | UnexpectedError>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetBasketSummaryHook>>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetBasketSummaryQueryOptions(options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Get the current basket for the user. If no basket exists yet, a new one will be created and returned.
 */
export const useGetBasketHook = () => {
        const getBasket = useMutator<GetBasketResponse>();

        return useCallback((
    
 signal?: AbortSignal
) => {
        return getBasket(
          {url: `/consumer-sender-services/basket`, method: 'GET', signal
    },
          );
        }, [getBasket])
      }
    

export const getGetBasketQueryKey = () => {
    return [`/consumer-sender-services/basket`] as const;
    }

    
export const useGetBasketQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetBasketHook>>>, TError = DecodingError | AuthenticationError | UnexpectedError>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetBasketHook>>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetBasketQueryKey();

  const getBasket =  useGetBasketHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetBasketHook>>>> = ({ signal }) => getBasket(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetBasketHook>>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetBasketQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetBasketHook>>>>
export type GetBasketQueryError = DecodingError | AuthenticationError | UnexpectedError


export function useGetBasket<TData = Awaited<ReturnType<ReturnType<typeof useGetBasketHook>>>, TError = DecodingError | AuthenticationError | UnexpectedError>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetBasketHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetBasketHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetBasketHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBasket<TData = Awaited<ReturnType<ReturnType<typeof useGetBasketHook>>>, TError = DecodingError | AuthenticationError | UnexpectedError>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetBasketHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetBasketHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetBasketHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBasket<TData = Awaited<ReturnType<ReturnType<typeof useGetBasketHook>>>, TError = DecodingError | AuthenticationError | UnexpectedError>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetBasketHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetBasket<TData = Awaited<ReturnType<ReturnType<typeof useGetBasketHook>>>, TError = DecodingError | AuthenticationError | UnexpectedError>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetBasketHook>>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetBasketQueryOptions(options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const useClearBasketHook = () => {
        const clearBasket = useMutator<null>();

        return useCallback((
    
 ) => {
        return clearBasket(
          {url: `/consumer-sender-services/basket`, method: 'DELETE'
    },
          );
        }, [clearBasket])
      }
    


export const useClearBasketMutationOptions = <TError = DecodingError | AuthenticationError | UnexpectedError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useClearBasketHook>>>, TError,void, TContext>, }
): UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useClearBasketHook>>>, TError,void, TContext> => {

const mutationKey = ['clearBasket'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      const clearBasket =  useClearBasketHook()


      const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof useClearBasketHook>>>, void> = () => {
          

          return  clearBasket()
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ClearBasketMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useClearBasketHook>>>>
    
    export type ClearBasketMutationError = DecodingError | AuthenticationError | UnexpectedError

    export const useClearBasket = <TError = DecodingError | AuthenticationError | UnexpectedError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useClearBasketHook>>>, TError,void, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<ReturnType<typeof useClearBasketHook>>>,
        TError,
        void,
        TContext
      > => {

      const mutationOptions = useClearBasketMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
export const useAddItemSelectionToBasketHook = () => {
        const addItemSelectionToBasket = useMutator<AddItemSelectionToBasketResponse>();

        return useCallback((
    product: string,
    addItemSelectionToBasketRequest: AddItemSelectionToBasketRequest,
 signal?: AbortSignal
) => {
        return addItemSelectionToBasket(
          {url: `/consumer-sender-services/basket/products/${product}/item-selection`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: addItemSelectionToBasketRequest, signal
    },
          );
        }, [addItemSelectionToBasket])
      }
    


export const useAddItemSelectionToBasketMutationOptions = <TError = AddItemSelectionToBasket400 | AuthenticationError | UnexpectedError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useAddItemSelectionToBasketHook>>>, TError,{product: string;data: AddItemSelectionToBasketRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useAddItemSelectionToBasketHook>>>, TError,{product: string;data: AddItemSelectionToBasketRequest}, TContext> => {

const mutationKey = ['addItemSelectionToBasket'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      const addItemSelectionToBasket =  useAddItemSelectionToBasketHook()


      const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof useAddItemSelectionToBasketHook>>>, {product: string;data: AddItemSelectionToBasketRequest}> = (props) => {
          const {product,data} = props ?? {};

          return  addItemSelectionToBasket(product,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AddItemSelectionToBasketMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useAddItemSelectionToBasketHook>>>>
    export type AddItemSelectionToBasketMutationBody = AddItemSelectionToBasketRequest
    export type AddItemSelectionToBasketMutationError = AddItemSelectionToBasket400 | AuthenticationError | UnexpectedError

    export const useAddItemSelectionToBasket = <TError = AddItemSelectionToBasket400 | AuthenticationError | UnexpectedError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useAddItemSelectionToBasketHook>>>, TError,{product: string;data: AddItemSelectionToBasketRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<ReturnType<typeof useAddItemSelectionToBasketHook>>>,
        TError,
        {product: string;data: AddItemSelectionToBasketRequest},
        TContext
      > => {

      const mutationOptions = useAddItemSelectionToBasketMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
export const useChangeHandoverHook = () => {
        const changeHandover = useMutator<null>();

        return useCallback((
    carrier: string,
    changeHandoverOptionRequest: ChangeHandoverOptionRequest,
 ) => {
        return changeHandover(
          {url: `/consumer-sender-services/basket/carriers/${carrier}/handover`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: changeHandoverOptionRequest
    },
          );
        }, [changeHandover])
      }
    


export const useChangeHandoverMutationOptions = <TError = ChangeHandover400 | AuthenticationError | UnexpectedError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useChangeHandoverHook>>>, TError,{carrier: string;data: ChangeHandoverOptionRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useChangeHandoverHook>>>, TError,{carrier: string;data: ChangeHandoverOptionRequest}, TContext> => {

const mutationKey = ['changeHandover'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      const changeHandover =  useChangeHandoverHook()


      const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof useChangeHandoverHook>>>, {carrier: string;data: ChangeHandoverOptionRequest}> = (props) => {
          const {carrier,data} = props ?? {};

          return  changeHandover(carrier,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ChangeHandoverMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useChangeHandoverHook>>>>
    export type ChangeHandoverMutationBody = ChangeHandoverOptionRequest
    export type ChangeHandoverMutationError = ChangeHandover400 | AuthenticationError | UnexpectedError

    export const useChangeHandover = <TError = ChangeHandover400 | AuthenticationError | UnexpectedError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useChangeHandoverHook>>>, TError,{carrier: string;data: ChangeHandoverOptionRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<ReturnType<typeof useChangeHandoverHook>>>,
        TError,
        {carrier: string;data: ChangeHandoverOptionRequest},
        TContext
      > => {

      const mutationOptions = useChangeHandoverMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
export const useDeleteHandoverHook = () => {
        const deleteHandover = useMutator<null>();

        return useCallback((
    carrier: string,
 ) => {
        return deleteHandover(
          {url: `/consumer-sender-services/basket/carriers/${carrier}/handover`, method: 'DELETE'
    },
          );
        }, [deleteHandover])
      }
    


export const useDeleteHandoverMutationOptions = <TError = DeleteHandover400 | AuthenticationError | UnexpectedError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useDeleteHandoverHook>>>, TError,{carrier: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useDeleteHandoverHook>>>, TError,{carrier: string}, TContext> => {

const mutationKey = ['deleteHandover'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      const deleteHandover =  useDeleteHandoverHook()


      const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof useDeleteHandoverHook>>>, {carrier: string}> = (props) => {
          const {carrier} = props ?? {};

          return  deleteHandover(carrier,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteHandoverMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useDeleteHandoverHook>>>>
    
    export type DeleteHandoverMutationError = DeleteHandover400 | AuthenticationError | UnexpectedError

    export const useDeleteHandover = <TError = DeleteHandover400 | AuthenticationError | UnexpectedError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useDeleteHandoverHook>>>, TError,{carrier: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<ReturnType<typeof useDeleteHandoverHook>>>,
        TError,
        {carrier: string},
        TContext
      > => {

      const mutationOptions = useDeleteHandoverMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
export const useChangeLabelTypeHook = () => {
        const changeLabelType = useMutator<null>();

        return useCallback((
    carrier: string,
    changeLabelTypeRequest: ChangeLabelTypeRequest,
 ) => {
        return changeLabelType(
          {url: `/consumer-sender-services/basket/carriers/${carrier}/label-type`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: changeLabelTypeRequest
    },
          );
        }, [changeLabelType])
      }
    


export const useChangeLabelTypeMutationOptions = <TError = ChangeLabelType400 | AuthenticationError | UnexpectedError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useChangeLabelTypeHook>>>, TError,{carrier: string;data: ChangeLabelTypeRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useChangeLabelTypeHook>>>, TError,{carrier: string;data: ChangeLabelTypeRequest}, TContext> => {

const mutationKey = ['changeLabelType'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      const changeLabelType =  useChangeLabelTypeHook()


      const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof useChangeLabelTypeHook>>>, {carrier: string;data: ChangeLabelTypeRequest}> = (props) => {
          const {carrier,data} = props ?? {};

          return  changeLabelType(carrier,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ChangeLabelTypeMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useChangeLabelTypeHook>>>>
    export type ChangeLabelTypeMutationBody = ChangeLabelTypeRequest
    export type ChangeLabelTypeMutationError = ChangeLabelType400 | AuthenticationError | UnexpectedError

    export const useChangeLabelType = <TError = ChangeLabelType400 | AuthenticationError | UnexpectedError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useChangeLabelTypeHook>>>, TError,{carrier: string;data: ChangeLabelTypeRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<ReturnType<typeof useChangeLabelTypeHook>>>,
        TError,
        {carrier: string;data: ChangeLabelTypeRequest},
        TContext
      > => {

      const mutationOptions = useChangeLabelTypeMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
export const useDeleteLabelTypeHook = () => {
        const deleteLabelType = useMutator<null>();

        return useCallback((
    carrier: string,
 ) => {
        return deleteLabelType(
          {url: `/consumer-sender-services/basket/carriers/${carrier}/label-type`, method: 'DELETE'
    },
          );
        }, [deleteLabelType])
      }
    


export const useDeleteLabelTypeMutationOptions = <TError = DeleteLabelType400 | AuthenticationError | UnexpectedError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useDeleteLabelTypeHook>>>, TError,{carrier: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useDeleteLabelTypeHook>>>, TError,{carrier: string}, TContext> => {

const mutationKey = ['deleteLabelType'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      const deleteLabelType =  useDeleteLabelTypeHook()


      const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof useDeleteLabelTypeHook>>>, {carrier: string}> = (props) => {
          const {carrier} = props ?? {};

          return  deleteLabelType(carrier,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteLabelTypeMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useDeleteLabelTypeHook>>>>
    
    export type DeleteLabelTypeMutationError = DeleteLabelType400 | AuthenticationError | UnexpectedError

    export const useDeleteLabelType = <TError = DeleteLabelType400 | AuthenticationError | UnexpectedError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useDeleteLabelTypeHook>>>, TError,{carrier: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<ReturnType<typeof useDeleteLabelTypeHook>>>,
        TError,
        {carrier: string},
        TContext
      > => {

      const mutationOptions = useDeleteLabelTypeMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
export const useGetHandoverOptionsForBasketHook = () => {
        const getHandoverOptionsForBasket = useMutator<CarrierHandoverOptionsTypes[]>();

        return useCallback((
    params?: GetHandoverOptionsForBasketParams,
 signal?: AbortSignal
) => {
        return getHandoverOptionsForBasket(
          {url: `/consumer-sender-services/basket/handover-options`, method: 'GET',
        params, signal
    },
          );
        }, [getHandoverOptionsForBasket])
      }
    

export const getGetHandoverOptionsForBasketQueryKey = (params?: GetHandoverOptionsForBasketParams,) => {
    return [`/consumer-sender-services/basket/handover-options`, ...(params ? [params]: [])] as const;
    }

    
export const useGetHandoverOptionsForBasketQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetHandoverOptionsForBasketHook>>>, TError = DecodingError | AuthenticationError | UnexpectedError>(params?: GetHandoverOptionsForBasketParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetHandoverOptionsForBasketHook>>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetHandoverOptionsForBasketQueryKey(params);

  const getHandoverOptionsForBasket =  useGetHandoverOptionsForBasketHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetHandoverOptionsForBasketHook>>>> = ({ signal }) => getHandoverOptionsForBasket(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetHandoverOptionsForBasketHook>>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetHandoverOptionsForBasketQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetHandoverOptionsForBasketHook>>>>
export type GetHandoverOptionsForBasketQueryError = DecodingError | AuthenticationError | UnexpectedError


export function useGetHandoverOptionsForBasket<TData = Awaited<ReturnType<ReturnType<typeof useGetHandoverOptionsForBasketHook>>>, TError = DecodingError | AuthenticationError | UnexpectedError>(
 params: undefined |  GetHandoverOptionsForBasketParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetHandoverOptionsForBasketHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetHandoverOptionsForBasketHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetHandoverOptionsForBasketHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetHandoverOptionsForBasket<TData = Awaited<ReturnType<ReturnType<typeof useGetHandoverOptionsForBasketHook>>>, TError = DecodingError | AuthenticationError | UnexpectedError>(
 params?: GetHandoverOptionsForBasketParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetHandoverOptionsForBasketHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetHandoverOptionsForBasketHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetHandoverOptionsForBasketHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetHandoverOptionsForBasket<TData = Awaited<ReturnType<ReturnType<typeof useGetHandoverOptionsForBasketHook>>>, TError = DecodingError | AuthenticationError | UnexpectedError>(
 params?: GetHandoverOptionsForBasketParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetHandoverOptionsForBasketHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetHandoverOptionsForBasket<TData = Awaited<ReturnType<ReturnType<typeof useGetHandoverOptionsForBasketHook>>>, TError = DecodingError | AuthenticationError | UnexpectedError>(
 params?: GetHandoverOptionsForBasketParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetHandoverOptionsForBasketHook>>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetHandoverOptionsForBasketQueryOptions(params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const useGetLabelTypesForBasketHook = () => {
        const getLabelTypesForBasket = useMutator<CarrierLabelTypes[]>();

        return useCallback((
    
 signal?: AbortSignal
) => {
        return getLabelTypesForBasket(
          {url: `/consumer-sender-services/basket/label-types`, method: 'GET', signal
    },
          );
        }, [getLabelTypesForBasket])
      }
    

export const getGetLabelTypesForBasketQueryKey = () => {
    return [`/consumer-sender-services/basket/label-types`] as const;
    }

    
export const useGetLabelTypesForBasketQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetLabelTypesForBasketHook>>>, TError = DecodingError | AuthenticationError | UnexpectedError>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetLabelTypesForBasketHook>>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetLabelTypesForBasketQueryKey();

  const getLabelTypesForBasket =  useGetLabelTypesForBasketHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetLabelTypesForBasketHook>>>> = ({ signal }) => getLabelTypesForBasket(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetLabelTypesForBasketHook>>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetLabelTypesForBasketQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetLabelTypesForBasketHook>>>>
export type GetLabelTypesForBasketQueryError = DecodingError | AuthenticationError | UnexpectedError


export function useGetLabelTypesForBasket<TData = Awaited<ReturnType<ReturnType<typeof useGetLabelTypesForBasketHook>>>, TError = DecodingError | AuthenticationError | UnexpectedError>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetLabelTypesForBasketHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetLabelTypesForBasketHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetLabelTypesForBasketHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLabelTypesForBasket<TData = Awaited<ReturnType<ReturnType<typeof useGetLabelTypesForBasketHook>>>, TError = DecodingError | AuthenticationError | UnexpectedError>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetLabelTypesForBasketHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetLabelTypesForBasketHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetLabelTypesForBasketHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLabelTypesForBasket<TData = Awaited<ReturnType<ReturnType<typeof useGetLabelTypesForBasketHook>>>, TError = DecodingError | AuthenticationError | UnexpectedError>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetLabelTypesForBasketHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetLabelTypesForBasket<TData = Awaited<ReturnType<ReturnType<typeof useGetLabelTypesForBasketHook>>>, TError = DecodingError | AuthenticationError | UnexpectedError>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetLabelTypesForBasketHook>>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetLabelTypesForBasketQueryOptions(options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const useRestoreArchivedBasketHook = () => {
        const restoreArchivedBasket = useMutator<null>();

        return useCallback((
    
 signal?: AbortSignal
) => {
        return restoreArchivedBasket(
          {url: `/consumer-sender-services/basket/restore`, method: 'POST', signal
    },
          );
        }, [restoreArchivedBasket])
      }
    


export const useRestoreArchivedBasketMutationOptions = <TError = DecodingError | AuthenticationError | UnexpectedError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useRestoreArchivedBasketHook>>>, TError,void, TContext>, }
): UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useRestoreArchivedBasketHook>>>, TError,void, TContext> => {

const mutationKey = ['restoreArchivedBasket'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      const restoreArchivedBasket =  useRestoreArchivedBasketHook()


      const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof useRestoreArchivedBasketHook>>>, void> = () => {
          

          return  restoreArchivedBasket()
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type RestoreArchivedBasketMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useRestoreArchivedBasketHook>>>>
    
    export type RestoreArchivedBasketMutationError = DecodingError | AuthenticationError | UnexpectedError

    export const useRestoreArchivedBasket = <TError = DecodingError | AuthenticationError | UnexpectedError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useRestoreArchivedBasketHook>>>, TError,void, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<ReturnType<typeof useRestoreArchivedBasketHook>>>,
        TError,
        void,
        TContext
      > => {

      const mutationOptions = useRestoreArchivedBasketMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
export const useVerifyDiscountCodeForBasketHook = () => {
        const verifyDiscountCodeForBasket = useMutator<VerifyDiscountCodeForBasketResponse>();

        return useCallback((
    verifyDiscountCodeForBasketRequest: VerifyDiscountCodeForBasketRequest,
 signal?: AbortSignal
) => {
        return verifyDiscountCodeForBasket(
          {url: `/consumer-sender-services/basket/discount-code/verify`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: verifyDiscountCodeForBasketRequest, signal
    },
          );
        }, [verifyDiscountCodeForBasket])
      }
    


export const useVerifyDiscountCodeForBasketMutationOptions = <TError = VerifyDiscountCodeForBasket400 | AuthenticationError | UnexpectedError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useVerifyDiscountCodeForBasketHook>>>, TError,{data: VerifyDiscountCodeForBasketRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useVerifyDiscountCodeForBasketHook>>>, TError,{data: VerifyDiscountCodeForBasketRequest}, TContext> => {

const mutationKey = ['verifyDiscountCodeForBasket'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      const verifyDiscountCodeForBasket =  useVerifyDiscountCodeForBasketHook()


      const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof useVerifyDiscountCodeForBasketHook>>>, {data: VerifyDiscountCodeForBasketRequest}> = (props) => {
          const {data} = props ?? {};

          return  verifyDiscountCodeForBasket(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type VerifyDiscountCodeForBasketMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useVerifyDiscountCodeForBasketHook>>>>
    export type VerifyDiscountCodeForBasketMutationBody = VerifyDiscountCodeForBasketRequest
    export type VerifyDiscountCodeForBasketMutationError = VerifyDiscountCodeForBasket400 | AuthenticationError | UnexpectedError

    export const useVerifyDiscountCodeForBasket = <TError = VerifyDiscountCodeForBasket400 | AuthenticationError | UnexpectedError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useVerifyDiscountCodeForBasketHook>>>, TError,{data: VerifyDiscountCodeForBasketRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<ReturnType<typeof useVerifyDiscountCodeForBasketHook>>>,
        TError,
        {data: VerifyDiscountCodeForBasketRequest},
        TContext
      > => {

      const mutationOptions = useVerifyDiscountCodeForBasketMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
export const useGetBasketItemHook = () => {
        const getBasketItem = useMutator<GetBasketItemResponse>();

        return useCallback((
    item: string,
 signal?: AbortSignal
) => {
        return getBasketItem(
          {url: `/consumer-sender-services/basket/items/${item}`, method: 'GET', signal
    },
          );
        }, [getBasketItem])
      }
    

export const getGetBasketItemQueryKey = (item?: string,) => {
    return [`/consumer-sender-services/basket/items/${item}`] as const;
    }

    
export const useGetBasketItemQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetBasketItemHook>>>, TError = DecodingError | AuthenticationError | NotFound | UnexpectedError>(item: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetBasketItemHook>>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetBasketItemQueryKey(item);

  const getBasketItem =  useGetBasketItemHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetBasketItemHook>>>> = ({ signal }) => getBasketItem(item, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(item), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetBasketItemHook>>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetBasketItemQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetBasketItemHook>>>>
export type GetBasketItemQueryError = DecodingError | AuthenticationError | NotFound | UnexpectedError


export function useGetBasketItem<TData = Awaited<ReturnType<ReturnType<typeof useGetBasketItemHook>>>, TError = DecodingError | AuthenticationError | NotFound | UnexpectedError>(
 item: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetBasketItemHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetBasketItemHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetBasketItemHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBasketItem<TData = Awaited<ReturnType<ReturnType<typeof useGetBasketItemHook>>>, TError = DecodingError | AuthenticationError | NotFound | UnexpectedError>(
 item: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetBasketItemHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetBasketItemHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetBasketItemHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBasketItem<TData = Awaited<ReturnType<ReturnType<typeof useGetBasketItemHook>>>, TError = DecodingError | AuthenticationError | NotFound | UnexpectedError>(
 item: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetBasketItemHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetBasketItem<TData = Awaited<ReturnType<ReturnType<typeof useGetBasketItemHook>>>, TError = DecodingError | AuthenticationError | NotFound | UnexpectedError>(
 item: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetBasketItemHook>>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetBasketItemQueryOptions(item,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const useUpdateItemInBasketHook = () => {
        const updateItemInBasket = useMutator<null>();

        return useCallback((
    item: string,
    basketItemUpdateRequest: BasketItemUpdateRequest,
 ) => {
        return updateItemInBasket(
          {url: `/consumer-sender-services/basket/items/${item}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: basketItemUpdateRequest
    },
          );
        }, [updateItemInBasket])
      }
    


export const useUpdateItemInBasketMutationOptions = <TError = UpdateItemInBasket400 | AuthenticationError | NotFound | UnexpectedError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useUpdateItemInBasketHook>>>, TError,{item: string;data: BasketItemUpdateRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useUpdateItemInBasketHook>>>, TError,{item: string;data: BasketItemUpdateRequest}, TContext> => {

const mutationKey = ['updateItemInBasket'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      const updateItemInBasket =  useUpdateItemInBasketHook()


      const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof useUpdateItemInBasketHook>>>, {item: string;data: BasketItemUpdateRequest}> = (props) => {
          const {item,data} = props ?? {};

          return  updateItemInBasket(item,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateItemInBasketMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useUpdateItemInBasketHook>>>>
    export type UpdateItemInBasketMutationBody = BasketItemUpdateRequest
    export type UpdateItemInBasketMutationError = UpdateItemInBasket400 | AuthenticationError | NotFound | UnexpectedError

    export const useUpdateItemInBasket = <TError = UpdateItemInBasket400 | AuthenticationError | NotFound | UnexpectedError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useUpdateItemInBasketHook>>>, TError,{item: string;data: BasketItemUpdateRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<ReturnType<typeof useUpdateItemInBasketHook>>>,
        TError,
        {item: string;data: BasketItemUpdateRequest},
        TContext
      > => {

      const mutationOptions = useUpdateItemInBasketMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
export const useRemoveItemFromBasketHook = () => {
        const removeItemFromBasket = useMutator<null>();

        return useCallback((
    item: string,
 ) => {
        return removeItemFromBasket(
          {url: `/consumer-sender-services/basket/items/${item}`, method: 'DELETE'
    },
          );
        }, [removeItemFromBasket])
      }
    


export const useRemoveItemFromBasketMutationOptions = <TError = DecodingError | AuthenticationError | UnexpectedError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useRemoveItemFromBasketHook>>>, TError,{item: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useRemoveItemFromBasketHook>>>, TError,{item: string}, TContext> => {

const mutationKey = ['removeItemFromBasket'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      const removeItemFromBasket =  useRemoveItemFromBasketHook()


      const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof useRemoveItemFromBasketHook>>>, {item: string}> = (props) => {
          const {item} = props ?? {};

          return  removeItemFromBasket(item,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type RemoveItemFromBasketMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useRemoveItemFromBasketHook>>>>
    
    export type RemoveItemFromBasketMutationError = DecodingError | AuthenticationError | UnexpectedError

    export const useRemoveItemFromBasket = <TError = DecodingError | AuthenticationError | UnexpectedError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useRemoveItemFromBasketHook>>>, TError,{item: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<ReturnType<typeof useRemoveItemFromBasketHook>>>,
        TError,
        {item: string},
        TContext
      > => {

      const mutationOptions = useRemoveItemFromBasketMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
export const useGetDeliveryOptionsForBasketItemHook = () => {
        const getDeliveryOptionsForBasketItem = useMutator<GetDeliveryOptionsBasketItemResponse>();

        return useCallback((
    item: string,
    params?: GetDeliveryOptionsForBasketItemParams,
 signal?: AbortSignal
) => {
        return getDeliveryOptionsForBasketItem(
          {url: `/consumer-sender-services/basket/items/${item}/delivery-options`, method: 'GET',
        params, signal
    },
          );
        }, [getDeliveryOptionsForBasketItem])
      }
    

export const getGetDeliveryOptionsForBasketItemQueryKey = (item?: string,
    params?: GetDeliveryOptionsForBasketItemParams,) => {
    return [`/consumer-sender-services/basket/items/${item}/delivery-options`, ...(params ? [params]: [])] as const;
    }

    
export const useGetDeliveryOptionsForBasketItemQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetDeliveryOptionsForBasketItemHook>>>, TError = DecodingError | AuthenticationError | UnexpectedError>(item: string,
    params?: GetDeliveryOptionsForBasketItemParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetDeliveryOptionsForBasketItemHook>>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDeliveryOptionsForBasketItemQueryKey(item,params);

  const getDeliveryOptionsForBasketItem =  useGetDeliveryOptionsForBasketItemHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetDeliveryOptionsForBasketItemHook>>>> = ({ signal }) => getDeliveryOptionsForBasketItem(item,params, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(item), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetDeliveryOptionsForBasketItemHook>>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetDeliveryOptionsForBasketItemQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetDeliveryOptionsForBasketItemHook>>>>
export type GetDeliveryOptionsForBasketItemQueryError = DecodingError | AuthenticationError | UnexpectedError


export function useGetDeliveryOptionsForBasketItem<TData = Awaited<ReturnType<ReturnType<typeof useGetDeliveryOptionsForBasketItemHook>>>, TError = DecodingError | AuthenticationError | UnexpectedError>(
 item: string,
    params: undefined |  GetDeliveryOptionsForBasketItemParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetDeliveryOptionsForBasketItemHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetDeliveryOptionsForBasketItemHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetDeliveryOptionsForBasketItemHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDeliveryOptionsForBasketItem<TData = Awaited<ReturnType<ReturnType<typeof useGetDeliveryOptionsForBasketItemHook>>>, TError = DecodingError | AuthenticationError | UnexpectedError>(
 item: string,
    params?: GetDeliveryOptionsForBasketItemParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetDeliveryOptionsForBasketItemHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetDeliveryOptionsForBasketItemHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetDeliveryOptionsForBasketItemHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDeliveryOptionsForBasketItem<TData = Awaited<ReturnType<ReturnType<typeof useGetDeliveryOptionsForBasketItemHook>>>, TError = DecodingError | AuthenticationError | UnexpectedError>(
 item: string,
    params?: GetDeliveryOptionsForBasketItemParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetDeliveryOptionsForBasketItemHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetDeliveryOptionsForBasketItem<TData = Awaited<ReturnType<ReturnType<typeof useGetDeliveryOptionsForBasketItemHook>>>, TError = DecodingError | AuthenticationError | UnexpectedError>(
 item: string,
    params?: GetDeliveryOptionsForBasketItemParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetDeliveryOptionsForBasketItemHook>>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetDeliveryOptionsForBasketItemQueryOptions(item,params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const useGetServiceOptionsForBasketItemHook = () => {
        const getServiceOptionsForBasketItem = useMutator<GetServiceOptionsBasketItemResponse>();

        return useCallback((
    item: string,
    params?: GetServiceOptionsForBasketItemParams,
 signal?: AbortSignal
) => {
        return getServiceOptionsForBasketItem(
          {url: `/consumer-sender-services/basket/items/${item}/service-options`, method: 'GET',
        params, signal
    },
          );
        }, [getServiceOptionsForBasketItem])
      }
    

export const getGetServiceOptionsForBasketItemQueryKey = (item?: string,
    params?: GetServiceOptionsForBasketItemParams,) => {
    return [`/consumer-sender-services/basket/items/${item}/service-options`, ...(params ? [params]: [])] as const;
    }

    
export const useGetServiceOptionsForBasketItemQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetServiceOptionsForBasketItemHook>>>, TError = DecodingError | AuthenticationError | UnexpectedError>(item: string,
    params?: GetServiceOptionsForBasketItemParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetServiceOptionsForBasketItemHook>>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetServiceOptionsForBasketItemQueryKey(item,params);

  const getServiceOptionsForBasketItem =  useGetServiceOptionsForBasketItemHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetServiceOptionsForBasketItemHook>>>> = ({ signal }) => getServiceOptionsForBasketItem(item,params, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(item), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetServiceOptionsForBasketItemHook>>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetServiceOptionsForBasketItemQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetServiceOptionsForBasketItemHook>>>>
export type GetServiceOptionsForBasketItemQueryError = DecodingError | AuthenticationError | UnexpectedError


export function useGetServiceOptionsForBasketItem<TData = Awaited<ReturnType<ReturnType<typeof useGetServiceOptionsForBasketItemHook>>>, TError = DecodingError | AuthenticationError | UnexpectedError>(
 item: string,
    params: undefined |  GetServiceOptionsForBasketItemParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetServiceOptionsForBasketItemHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetServiceOptionsForBasketItemHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetServiceOptionsForBasketItemHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetServiceOptionsForBasketItem<TData = Awaited<ReturnType<ReturnType<typeof useGetServiceOptionsForBasketItemHook>>>, TError = DecodingError | AuthenticationError | UnexpectedError>(
 item: string,
    params?: GetServiceOptionsForBasketItemParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetServiceOptionsForBasketItemHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetServiceOptionsForBasketItemHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetServiceOptionsForBasketItemHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetServiceOptionsForBasketItem<TData = Awaited<ReturnType<ReturnType<typeof useGetServiceOptionsForBasketItemHook>>>, TError = DecodingError | AuthenticationError | UnexpectedError>(
 item: string,
    params?: GetServiceOptionsForBasketItemParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetServiceOptionsForBasketItemHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetServiceOptionsForBasketItem<TData = Awaited<ReturnType<ReturnType<typeof useGetServiceOptionsForBasketItemHook>>>, TError = DecodingError | AuthenticationError | UnexpectedError>(
 item: string,
    params?: GetServiceOptionsForBasketItemParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetServiceOptionsForBasketItemHook>>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetServiceOptionsForBasketItemQueryOptions(item,params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const useAddDiscountCodeToBasketItemHook = () => {
        const addDiscountCodeToBasketItem = useMutator<null>();

        return useCallback((
    item: string,
    addDiscountCodeToBasketItemRequest: AddDiscountCodeToBasketItemRequest,
 ) => {
        return addDiscountCodeToBasketItem(
          {url: `/consumer-sender-services/basket/items/${item}/discount-code`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: addDiscountCodeToBasketItemRequest
    },
          );
        }, [addDiscountCodeToBasketItem])
      }
    


export const useAddDiscountCodeToBasketItemMutationOptions = <TError = AddDiscountCodeToBasketItem400 | AuthenticationError | UnexpectedError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useAddDiscountCodeToBasketItemHook>>>, TError,{item: string;data: AddDiscountCodeToBasketItemRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useAddDiscountCodeToBasketItemHook>>>, TError,{item: string;data: AddDiscountCodeToBasketItemRequest}, TContext> => {

const mutationKey = ['addDiscountCodeToBasketItem'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      const addDiscountCodeToBasketItem =  useAddDiscountCodeToBasketItemHook()


      const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof useAddDiscountCodeToBasketItemHook>>>, {item: string;data: AddDiscountCodeToBasketItemRequest}> = (props) => {
          const {item,data} = props ?? {};

          return  addDiscountCodeToBasketItem(item,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AddDiscountCodeToBasketItemMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useAddDiscountCodeToBasketItemHook>>>>
    export type AddDiscountCodeToBasketItemMutationBody = AddDiscountCodeToBasketItemRequest
    export type AddDiscountCodeToBasketItemMutationError = AddDiscountCodeToBasketItem400 | AuthenticationError | UnexpectedError

    export const useAddDiscountCodeToBasketItem = <TError = AddDiscountCodeToBasketItem400 | AuthenticationError | UnexpectedError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useAddDiscountCodeToBasketItemHook>>>, TError,{item: string;data: AddDiscountCodeToBasketItemRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<ReturnType<typeof useAddDiscountCodeToBasketItemHook>>>,
        TError,
        {item: string;data: AddDiscountCodeToBasketItemRequest},
        TContext
      > => {

      const mutationOptions = useAddDiscountCodeToBasketItemMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
export const useRemoveDiscountCodeToBasketItemHook = () => {
        const removeDiscountCodeToBasketItem = useMutator<null>();

        return useCallback((
    item: string,
 ) => {
        return removeDiscountCodeToBasketItem(
          {url: `/consumer-sender-services/basket/items/${item}/discount-code`, method: 'DELETE'
    },
          );
        }, [removeDiscountCodeToBasketItem])
      }
    


export const useRemoveDiscountCodeToBasketItemMutationOptions = <TError = DecodingError | AuthenticationError | UnexpectedError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useRemoveDiscountCodeToBasketItemHook>>>, TError,{item: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useRemoveDiscountCodeToBasketItemHook>>>, TError,{item: string}, TContext> => {

const mutationKey = ['removeDiscountCodeToBasketItem'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      const removeDiscountCodeToBasketItem =  useRemoveDiscountCodeToBasketItemHook()


      const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof useRemoveDiscountCodeToBasketItemHook>>>, {item: string}> = (props) => {
          const {item} = props ?? {};

          return  removeDiscountCodeToBasketItem(item,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type RemoveDiscountCodeToBasketItemMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useRemoveDiscountCodeToBasketItemHook>>>>
    
    export type RemoveDiscountCodeToBasketItemMutationError = DecodingError | AuthenticationError | UnexpectedError

    export const useRemoveDiscountCodeToBasketItem = <TError = DecodingError | AuthenticationError | UnexpectedError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useRemoveDiscountCodeToBasketItemHook>>>, TError,{item: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<ReturnType<typeof useRemoveDiscountCodeToBasketItemHook>>>,
        TError,
        {item: string},
        TContext
      > => {

      const mutationOptions = useRemoveDiscountCodeToBasketItemMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Get the list of payment options that are available for this basket
 */
export const useGetPaymentMethodsHook = () => {
        const getPaymentMethods = useMutator<GetPaymentMethodsResponse>();

        return useCallback((
    
 signal?: AbortSignal
) => {
        return getPaymentMethods(
          {url: `/consumer-sender-services/basket/payment/methods`, method: 'GET', signal
    },
          );
        }, [getPaymentMethods])
      }
    

export const getGetPaymentMethodsQueryKey = () => {
    return [`/consumer-sender-services/basket/payment/methods`] as const;
    }

    
export const useGetPaymentMethodsQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetPaymentMethodsHook>>>, TError = DecodingError | AuthenticationError | UnexpectedError>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetPaymentMethodsHook>>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPaymentMethodsQueryKey();

  const getPaymentMethods =  useGetPaymentMethodsHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetPaymentMethodsHook>>>> = ({ signal }) => getPaymentMethods(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetPaymentMethodsHook>>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPaymentMethodsQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetPaymentMethodsHook>>>>
export type GetPaymentMethodsQueryError = DecodingError | AuthenticationError | UnexpectedError


export function useGetPaymentMethods<TData = Awaited<ReturnType<ReturnType<typeof useGetPaymentMethodsHook>>>, TError = DecodingError | AuthenticationError | UnexpectedError>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetPaymentMethodsHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetPaymentMethodsHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetPaymentMethodsHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPaymentMethods<TData = Awaited<ReturnType<ReturnType<typeof useGetPaymentMethodsHook>>>, TError = DecodingError | AuthenticationError | UnexpectedError>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetPaymentMethodsHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetPaymentMethodsHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetPaymentMethodsHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPaymentMethods<TData = Awaited<ReturnType<ReturnType<typeof useGetPaymentMethodsHook>>>, TError = DecodingError | AuthenticationError | UnexpectedError>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetPaymentMethodsHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetPaymentMethods<TData = Awaited<ReturnType<ReturnType<typeof useGetPaymentMethodsHook>>>, TError = DecodingError | AuthenticationError | UnexpectedError>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetPaymentMethodsHook>>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetPaymentMethodsQueryOptions(options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Start the payment process for the basket
 */
export const useStartPaymentPostHook = () => {
        const startPaymentPost = useMutator<StartPaymentResponse>();

        return useCallback((
    startPaymentRequest: StartPaymentRequest,
 signal?: AbortSignal
) => {
        return startPaymentPost(
          {url: `/consumer-sender-services/basket/payment`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: startPaymentRequest, signal
    },
          );
        }, [startPaymentPost])
      }
    


export const useStartPaymentPostMutationOptions = <TError = StartPaymentPost400 | AuthenticationError | OrderCreationFailed | UnexpectedError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useStartPaymentPostHook>>>, TError,{data: StartPaymentRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useStartPaymentPostHook>>>, TError,{data: StartPaymentRequest}, TContext> => {

const mutationKey = ['startPaymentPost'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      const startPaymentPost =  useStartPaymentPostHook()


      const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof useStartPaymentPostHook>>>, {data: StartPaymentRequest}> = (props) => {
          const {data} = props ?? {};

          return  startPaymentPost(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type StartPaymentPostMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useStartPaymentPostHook>>>>
    export type StartPaymentPostMutationBody = StartPaymentRequest
    export type StartPaymentPostMutationError = StartPaymentPost400 | AuthenticationError | OrderCreationFailed | UnexpectedError

    export const useStartPaymentPost = <TError = StartPaymentPost400 | AuthenticationError | OrderCreationFailed | UnexpectedError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useStartPaymentPostHook>>>, TError,{data: StartPaymentRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<ReturnType<typeof useStartPaymentPostHook>>>,
        TError,
        {data: StartPaymentRequest},
        TContext
      > => {

      const mutationOptions = useStartPaymentPostMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Get the order based on the provided id.
 */
export const useGetOrderHook = () => {
        const getOrder = useMutator<GetOrderResponse>();

        return useCallback((
    orderId: string,
 signal?: AbortSignal
) => {
        return getOrder(
          {url: `/consumer-sender-services/orders/${orderId}`, method: 'GET', signal
    },
          );
        }, [getOrder])
      }
    

export const getGetOrderQueryKey = (orderId?: string,) => {
    return [`/consumer-sender-services/orders/${orderId}`] as const;
    }

    
export const useGetOrderQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetOrderHook>>>, TError = DecodingError | AuthenticationError | NotFound | UnexpectedError>(orderId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetOrderHook>>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetOrderQueryKey(orderId);

  const getOrder =  useGetOrderHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetOrderHook>>>> = ({ signal }) => getOrder(orderId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(orderId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetOrderHook>>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetOrderQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetOrderHook>>>>
export type GetOrderQueryError = DecodingError | AuthenticationError | NotFound | UnexpectedError


export function useGetOrder<TData = Awaited<ReturnType<ReturnType<typeof useGetOrderHook>>>, TError = DecodingError | AuthenticationError | NotFound | UnexpectedError>(
 orderId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetOrderHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetOrderHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetOrderHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOrder<TData = Awaited<ReturnType<ReturnType<typeof useGetOrderHook>>>, TError = DecodingError | AuthenticationError | NotFound | UnexpectedError>(
 orderId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetOrderHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetOrderHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetOrderHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOrder<TData = Awaited<ReturnType<ReturnType<typeof useGetOrderHook>>>, TError = DecodingError | AuthenticationError | NotFound | UnexpectedError>(
 orderId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetOrderHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetOrder<TData = Awaited<ReturnType<ReturnType<typeof useGetOrderHook>>>, TError = DecodingError | AuthenticationError | NotFound | UnexpectedError>(
 orderId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetOrderHook>>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetOrderQueryOptions(orderId,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Get the invoice for the order based on the provided id.
 */
export const useDownloadOrderInvoiceHook = () => {
        const downloadOrderInvoice = useMutator<Blob>();

        return useCallback((
    orderId: string,
    carrier: string,
 signal?: AbortSignal
) => {
        return downloadOrderInvoice(
          {url: `/consumer-sender-services/invoices/${orderId}/${carrier}`, method: 'GET',
        responseType: 'blob', signal
    },
          );
        }, [downloadOrderInvoice])
      }
    

export const getDownloadOrderInvoiceQueryKey = (orderId?: string,
    carrier?: string,) => {
    return [`/consumer-sender-services/invoices/${orderId}/${carrier}`] as const;
    }

    
export const useDownloadOrderInvoiceQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useDownloadOrderInvoiceHook>>>, TError = DecodingError | AuthenticationError | NotFound | UnexpectedError>(orderId: string,
    carrier: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useDownloadOrderInvoiceHook>>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDownloadOrderInvoiceQueryKey(orderId,carrier);

  const downloadOrderInvoice =  useDownloadOrderInvoiceHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useDownloadOrderInvoiceHook>>>> = ({ signal }) => downloadOrderInvoice(orderId,carrier, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(orderId && carrier), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useDownloadOrderInvoiceHook>>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type DownloadOrderInvoiceQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useDownloadOrderInvoiceHook>>>>
export type DownloadOrderInvoiceQueryError = DecodingError | AuthenticationError | NotFound | UnexpectedError


export function useDownloadOrderInvoice<TData = Awaited<ReturnType<ReturnType<typeof useDownloadOrderInvoiceHook>>>, TError = DecodingError | AuthenticationError | NotFound | UnexpectedError>(
 orderId: string,
    carrier: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useDownloadOrderInvoiceHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useDownloadOrderInvoiceHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useDownloadOrderInvoiceHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDownloadOrderInvoice<TData = Awaited<ReturnType<ReturnType<typeof useDownloadOrderInvoiceHook>>>, TError = DecodingError | AuthenticationError | NotFound | UnexpectedError>(
 orderId: string,
    carrier: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useDownloadOrderInvoiceHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useDownloadOrderInvoiceHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useDownloadOrderInvoiceHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDownloadOrderInvoice<TData = Awaited<ReturnType<ReturnType<typeof useDownloadOrderInvoiceHook>>>, TError = DecodingError | AuthenticationError | NotFound | UnexpectedError>(
 orderId: string,
    carrier: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useDownloadOrderInvoiceHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useDownloadOrderInvoice<TData = Awaited<ReturnType<ReturnType<typeof useDownloadOrderInvoiceHook>>>, TError = DecodingError | AuthenticationError | NotFound | UnexpectedError>(
 orderId: string,
    carrier: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useDownloadOrderInvoiceHook>>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useDownloadOrderInvoiceQueryOptions(orderId,carrier,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Test whether invoice exists
 */
export const useHeadOrderInvoiceHook = () => {
        const headOrderInvoice = useMutator<null>();

        return useCallback((
    orderId: string,
    carrier: string,
 signal?: AbortSignal
) => {
        return headOrderInvoice(
          {url: `/consumer-sender-services/invoices/${orderId}/${carrier}`, method: 'HEAD', signal
    },
          );
        }, [headOrderInvoice])
      }
    


export const useHeadOrderInvoiceMutationOptions = <TError = DecodingError | AuthenticationError | NotFound | UnexpectedError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useHeadOrderInvoiceHook>>>, TError,{orderId: string;carrier: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useHeadOrderInvoiceHook>>>, TError,{orderId: string;carrier: string}, TContext> => {

const mutationKey = ['headOrderInvoice'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      const headOrderInvoice =  useHeadOrderInvoiceHook()


      const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof useHeadOrderInvoiceHook>>>, {orderId: string;carrier: string}> = (props) => {
          const {orderId,carrier} = props ?? {};

          return  headOrderInvoice(orderId,carrier,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type HeadOrderInvoiceMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useHeadOrderInvoiceHook>>>>
    
    export type HeadOrderInvoiceMutationError = DecodingError | AuthenticationError | NotFound | UnexpectedError

    export const useHeadOrderInvoice = <TError = DecodingError | AuthenticationError | NotFound | UnexpectedError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useHeadOrderInvoiceHook>>>, TError,{orderId: string;carrier: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<ReturnType<typeof useHeadOrderInvoiceHook>>>,
        TError,
        {orderId: string;carrier: string},
        TContext
      > => {

      const mutationOptions = useHeadOrderInvoiceMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Get the downloadable label for the order and carrier
 */
export const useGetLabelsForCarrierHook = () => {
        const getLabelsForCarrier = useMutator<Blob>();

        return useCallback((
    orderId: string,
    carrier: string,
 signal?: AbortSignal
) => {
        return getLabelsForCarrier(
          {url: `/consumer-sender-services/labels/${orderId}/${carrier}`, method: 'GET',
        responseType: 'blob', signal
    },
          );
        }, [getLabelsForCarrier])
      }
    

export const getGetLabelsForCarrierQueryKey = (orderId?: string,
    carrier?: string,) => {
    return [`/consumer-sender-services/labels/${orderId}/${carrier}`] as const;
    }

    
export const useGetLabelsForCarrierQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetLabelsForCarrierHook>>>, TError = string | AuthenticationError1 | NotFound1 | Conflict | UnexpectedError1>(orderId: string,
    carrier: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetLabelsForCarrierHook>>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetLabelsForCarrierQueryKey(orderId,carrier);

  const getLabelsForCarrier =  useGetLabelsForCarrierHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetLabelsForCarrierHook>>>> = ({ signal }) => getLabelsForCarrier(orderId,carrier, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(orderId && carrier), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetLabelsForCarrierHook>>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetLabelsForCarrierQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetLabelsForCarrierHook>>>>
export type GetLabelsForCarrierQueryError = string | AuthenticationError1 | NotFound1 | Conflict | UnexpectedError1


export function useGetLabelsForCarrier<TData = Awaited<ReturnType<ReturnType<typeof useGetLabelsForCarrierHook>>>, TError = string | AuthenticationError1 | NotFound1 | Conflict | UnexpectedError1>(
 orderId: string,
    carrier: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetLabelsForCarrierHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetLabelsForCarrierHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetLabelsForCarrierHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLabelsForCarrier<TData = Awaited<ReturnType<ReturnType<typeof useGetLabelsForCarrierHook>>>, TError = string | AuthenticationError1 | NotFound1 | Conflict | UnexpectedError1>(
 orderId: string,
    carrier: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetLabelsForCarrierHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetLabelsForCarrierHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetLabelsForCarrierHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLabelsForCarrier<TData = Awaited<ReturnType<ReturnType<typeof useGetLabelsForCarrierHook>>>, TError = string | AuthenticationError1 | NotFound1 | Conflict | UnexpectedError1>(
 orderId: string,
    carrier: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetLabelsForCarrierHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetLabelsForCarrier<TData = Awaited<ReturnType<ReturnType<typeof useGetLabelsForCarrierHook>>>, TError = string | AuthenticationError1 | NotFound1 | Conflict | UnexpectedError1>(
 orderId: string,
    carrier: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetLabelsForCarrierHook>>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetLabelsForCarrierQueryOptions(orderId,carrier,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Test whether label exists
 */
export const useHeadLabelsForCarrierHook = () => {
        const headLabelsForCarrier = useMutator<null>();

        return useCallback((
    orderId: string,
    carrier: string,
 signal?: AbortSignal
) => {
        return headLabelsForCarrier(
          {url: `/consumer-sender-services/labels/${orderId}/${carrier}`, method: 'HEAD', signal
    },
          );
        }, [headLabelsForCarrier])
      }
    


export const useHeadLabelsForCarrierMutationOptions = <TError = string | AuthenticationError1 | NotFound1 | Conflict | UnexpectedError1,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useHeadLabelsForCarrierHook>>>, TError,{orderId: string;carrier: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useHeadLabelsForCarrierHook>>>, TError,{orderId: string;carrier: string}, TContext> => {

const mutationKey = ['headLabelsForCarrier'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      const headLabelsForCarrier =  useHeadLabelsForCarrierHook()


      const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof useHeadLabelsForCarrierHook>>>, {orderId: string;carrier: string}> = (props) => {
          const {orderId,carrier} = props ?? {};

          return  headLabelsForCarrier(orderId,carrier,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type HeadLabelsForCarrierMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useHeadLabelsForCarrierHook>>>>
    
    export type HeadLabelsForCarrierMutationError = string | AuthenticationError1 | NotFound1 | Conflict | UnexpectedError1

    export const useHeadLabelsForCarrier = <TError = string | AuthenticationError1 | NotFound1 | Conflict | UnexpectedError1,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useHeadLabelsForCarrierHook>>>, TError,{orderId: string;carrier: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<ReturnType<typeof useHeadLabelsForCarrierHook>>>,
        TError,
        {orderId: string;carrier: string},
        TContext
      > => {

      const mutationOptions = useHeadLabelsForCarrierMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Get the downloadable printless label instructions for the order and carrier
 */
export const useGetPrintlessLabelsForCarrierHook = () => {
        const getPrintlessLabelsForCarrier = useMutator<Blob>();

        return useCallback((
    orderId: string,
    carrier: string,
 signal?: AbortSignal
) => {
        return getPrintlessLabelsForCarrier(
          {url: `/consumer-sender-services/labels-printless/${orderId}/${carrier}`, method: 'GET',
        responseType: 'blob', signal
    },
          );
        }, [getPrintlessLabelsForCarrier])
      }
    

export const getGetPrintlessLabelsForCarrierQueryKey = (orderId?: string,
    carrier?: string,) => {
    return [`/consumer-sender-services/labels-printless/${orderId}/${carrier}`] as const;
    }

    
export const useGetPrintlessLabelsForCarrierQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetPrintlessLabelsForCarrierHook>>>, TError = string | AuthenticationError1 | NotFound1 | Conflict | UnexpectedError1>(orderId: string,
    carrier: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetPrintlessLabelsForCarrierHook>>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPrintlessLabelsForCarrierQueryKey(orderId,carrier);

  const getPrintlessLabelsForCarrier =  useGetPrintlessLabelsForCarrierHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetPrintlessLabelsForCarrierHook>>>> = ({ signal }) => getPrintlessLabelsForCarrier(orderId,carrier, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(orderId && carrier), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetPrintlessLabelsForCarrierHook>>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPrintlessLabelsForCarrierQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetPrintlessLabelsForCarrierHook>>>>
export type GetPrintlessLabelsForCarrierQueryError = string | AuthenticationError1 | NotFound1 | Conflict | UnexpectedError1


export function useGetPrintlessLabelsForCarrier<TData = Awaited<ReturnType<ReturnType<typeof useGetPrintlessLabelsForCarrierHook>>>, TError = string | AuthenticationError1 | NotFound1 | Conflict | UnexpectedError1>(
 orderId: string,
    carrier: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetPrintlessLabelsForCarrierHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetPrintlessLabelsForCarrierHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetPrintlessLabelsForCarrierHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPrintlessLabelsForCarrier<TData = Awaited<ReturnType<ReturnType<typeof useGetPrintlessLabelsForCarrierHook>>>, TError = string | AuthenticationError1 | NotFound1 | Conflict | UnexpectedError1>(
 orderId: string,
    carrier: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetPrintlessLabelsForCarrierHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetPrintlessLabelsForCarrierHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetPrintlessLabelsForCarrierHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPrintlessLabelsForCarrier<TData = Awaited<ReturnType<ReturnType<typeof useGetPrintlessLabelsForCarrierHook>>>, TError = string | AuthenticationError1 | NotFound1 | Conflict | UnexpectedError1>(
 orderId: string,
    carrier: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetPrintlessLabelsForCarrierHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetPrintlessLabelsForCarrier<TData = Awaited<ReturnType<ReturnType<typeof useGetPrintlessLabelsForCarrierHook>>>, TError = string | AuthenticationError1 | NotFound1 | Conflict | UnexpectedError1>(
 orderId: string,
    carrier: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetPrintlessLabelsForCarrierHook>>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetPrintlessLabelsForCarrierQueryOptions(orderId,carrier,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Test whether printless label exists
 */
export const useHeadPrintlessLabelsForCarrierHook = () => {
        const headPrintlessLabelsForCarrier = useMutator<null>();

        return useCallback((
    orderId: string,
    carrier: string,
 signal?: AbortSignal
) => {
        return headPrintlessLabelsForCarrier(
          {url: `/consumer-sender-services/labels-printless/${orderId}/${carrier}`, method: 'HEAD', signal
    },
          );
        }, [headPrintlessLabelsForCarrier])
      }
    


export const useHeadPrintlessLabelsForCarrierMutationOptions = <TError = string | AuthenticationError1 | NotFound1 | Conflict | UnexpectedError1,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useHeadPrintlessLabelsForCarrierHook>>>, TError,{orderId: string;carrier: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useHeadPrintlessLabelsForCarrierHook>>>, TError,{orderId: string;carrier: string}, TContext> => {

const mutationKey = ['headPrintlessLabelsForCarrier'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      const headPrintlessLabelsForCarrier =  useHeadPrintlessLabelsForCarrierHook()


      const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof useHeadPrintlessLabelsForCarrierHook>>>, {orderId: string;carrier: string}> = (props) => {
          const {orderId,carrier} = props ?? {};

          return  headPrintlessLabelsForCarrier(orderId,carrier,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type HeadPrintlessLabelsForCarrierMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useHeadPrintlessLabelsForCarrierHook>>>>
    
    export type HeadPrintlessLabelsForCarrierMutationError = string | AuthenticationError1 | NotFound1 | Conflict | UnexpectedError1

    export const useHeadPrintlessLabelsForCarrier = <TError = string | AuthenticationError1 | NotFound1 | Conflict | UnexpectedError1,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useHeadPrintlessLabelsForCarrierHook>>>, TError,{orderId: string;carrier: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<ReturnType<typeof useHeadPrintlessLabelsForCarrierHook>>>,
        TError,
        {orderId: string;carrier: string},
        TContext
      > => {

      const mutationOptions = useHeadPrintlessLabelsForCarrierMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Make a locker reservation for orders with a single ecommerce parcel
 */
export const useReserveLockerHook = () => {
        const reserveLocker = useMutator<null>();

        return useCallback((
    orderId: string,
    reserveLockerRequest: ReserveLockerRequest,
 signal?: AbortSignal
) => {
        return reserveLocker(
          {url: `/consumer-sender-services/orders/${orderId}/reserve-locker`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: reserveLockerRequest, signal
    },
          );
        }, [reserveLocker])
      }
    


export const useReserveLockerMutationOptions = <TError = string | AuthenticationError1 | Conflict | UnexpectedError1,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useReserveLockerHook>>>, TError,{orderId: string;data: ReserveLockerRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useReserveLockerHook>>>, TError,{orderId: string;data: ReserveLockerRequest}, TContext> => {

const mutationKey = ['reserveLocker'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      const reserveLocker =  useReserveLockerHook()


      const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof useReserveLockerHook>>>, {orderId: string;data: ReserveLockerRequest}> = (props) => {
          const {orderId,data} = props ?? {};

          return  reserveLocker(orderId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ReserveLockerMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useReserveLockerHook>>>>
    export type ReserveLockerMutationBody = ReserveLockerRequest
    export type ReserveLockerMutationError = string | AuthenticationError1 | Conflict | UnexpectedError1

    export const useReserveLocker = <TError = string | AuthenticationError1 | Conflict | UnexpectedError1,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useReserveLockerHook>>>, TError,{orderId: string;data: ReserveLockerRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<ReturnType<typeof useReserveLockerHook>>>,
        TError,
        {orderId: string;data: ReserveLockerRequest},
        TContext
      > => {

      const mutationOptions = useReserveLockerMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * analyse if the printless code is written well
 */
export const useUploadPrintlessPhotoHook = () => {
        const uploadPrintlessPhoto = useMutator<null>();

        return useCallback((
    orderId: string,
    uploadPrintlessPhotoBody: Blob,
 signal?: AbortSignal
) => {
        return uploadPrintlessPhoto(
          {url: `/consumer-sender-services/orders/${orderId}/upload-printless-photo`, method: 'POST',
      headers: {'Content-Type': 'application/octet-stream', },
      data: uploadPrintlessPhotoBody, signal
    },
          );
        }, [uploadPrintlessPhoto])
      }
    


export const useUploadPrintlessPhotoMutationOptions = <TError = string | AuthenticationError1 | Conflict | UnexpectedError1,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useUploadPrintlessPhotoHook>>>, TError,{orderId: string;data: Blob}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useUploadPrintlessPhotoHook>>>, TError,{orderId: string;data: Blob}, TContext> => {

const mutationKey = ['uploadPrintlessPhoto'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      const uploadPrintlessPhoto =  useUploadPrintlessPhotoHook()


      const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof useUploadPrintlessPhotoHook>>>, {orderId: string;data: Blob}> = (props) => {
          const {orderId,data} = props ?? {};

          return  uploadPrintlessPhoto(orderId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UploadPrintlessPhotoMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useUploadPrintlessPhotoHook>>>>
    export type UploadPrintlessPhotoMutationBody = Blob
    export type UploadPrintlessPhotoMutationError = string | AuthenticationError1 | Conflict | UnexpectedError1

    export const useUploadPrintlessPhoto = <TError = string | AuthenticationError1 | Conflict | UnexpectedError1,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useUploadPrintlessPhotoHook>>>, TError,{orderId: string;data: Blob}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<ReturnType<typeof useUploadPrintlessPhotoHook>>>,
        TError,
        {orderId: string;data: Blob},
        TContext
      > => {

      const mutationOptions = useUploadPrintlessPhotoMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
